// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:application/font-woff;charset=utf-8;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ag-theme-material {
  -webkit-font-smoothing: antialiased;
  color: rgba(0, 0, 0, 0.87);
  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));
  font-family: "Roboto", sans-serif;
  font-size: 13px;
  line-height: normal;
}
@font-face {
  font-family: "agGridMaterial";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
.ag-theme-material .ag-icon {
  font-family: "agGridMaterial";
  font-size: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.ag-theme-material .ag-icon-aggregation::before {
  content: "\\f101";
}
.ag-theme-material .ag-icon-arrows::before {
  content: "\\f102";
}
.ag-theme-material .ag-icon-asc::before {
  content: "\\f103";
}
.ag-theme-material .ag-icon-cancel::before {
  content: "\\f104";
}
.ag-theme-material .ag-icon-chart::before {
  content: "\\f105";
}
.ag-theme-material .ag-icon-color-picker::before {
  content: "\\f109";
}
.ag-theme-material .ag-icon-columns::before {
  content: "\\f10a";
}
.ag-theme-material .ag-icon-contracted::before {
  content: "\\f10b";
}
.ag-theme-material .ag-icon-copy::before {
  content: "\\f10c";
}
.ag-theme-material .ag-icon-cross::before {
  content: "\\f10d";
}
.ag-theme-material .ag-icon-csv::before {
  content: "\\f10e";
}
.ag-theme-material .ag-icon-desc::before {
  content: "\\f10f";
}
.ag-theme-material .ag-icon-excel::before {
  content: "\\f110";
}
.ag-theme-material .ag-icon-expanded::before {
  content: "\\f111";
}
.ag-theme-material .ag-icon-eye-slash::before {
  content: "\\f112";
}
.ag-theme-material .ag-icon-eye::before {
  content: "\\f113";
}
.ag-theme-material .ag-icon-filter::before {
  content: "\\f114";
}
.ag-theme-material .ag-icon-first::before {
  content: "\\f115";
}
.ag-theme-material .ag-icon-grip::before {
  content: "\\f116";
}
.ag-theme-material .ag-icon-group::before {
  content: "\\f117";
}
.ag-theme-material .ag-icon-last::before {
  content: "\\f118";
}
.ag-theme-material .ag-icon-left::before {
  content: "\\f119";
}
.ag-theme-material .ag-icon-linked::before {
  content: "\\f11a";
}
.ag-theme-material .ag-icon-loading::before {
  content: "\\f11b";
}
.ag-theme-material .ag-icon-maximize::before {
  content: "\\f11c";
}
.ag-theme-material .ag-icon-menu::before {
  content: "\\f11d";
}
.ag-theme-material .ag-icon-minimize::before {
  content: "\\f11e";
}
.ag-theme-material .ag-icon-next::before {
  content: "\\f11f";
}
.ag-theme-material .ag-icon-none::before {
  content: "\\f120";
}
.ag-theme-material .ag-icon-not-allowed::before {
  content: "\\f121";
}
.ag-theme-material .ag-icon-paste::before {
  content: "\\f122";
}
.ag-theme-material .ag-icon-pin::before {
  content: "\\f123";
}
.ag-theme-material .ag-icon-pivot::before {
  content: "\\f124";
}
.ag-theme-material .ag-icon-previous::before {
  content: "\\f125";
}
.ag-theme-material .ag-icon-right::before {
  content: "\\f128";
}
.ag-theme-material .ag-icon-save::before {
  content: "\\f129";
}
.ag-theme-material .ag-icon-small-down::before {
  content: "\\f12a";
}
.ag-theme-material .ag-icon-small-left::before {
  content: "\\f12b";
}
.ag-theme-material .ag-icon-small-right::before {
  content: "\\f12c";
}
.ag-theme-material .ag-icon-small-up::before {
  content: "\\f12d";
}
.ag-theme-material .ag-icon-tick::before {
  content: "\\f12e";
}
.ag-theme-material .ag-icon-tree-closed::before {
  content: "\\f12f";
}
.ag-theme-material .ag-icon-tree-indeterminate::before {
  content: "\\f130";
}
.ag-theme-material .ag-icon-tree-open::before {
  content: "\\f131";
}
.ag-theme-material .ag-icon-unlinked::before {
  content: "\\f132";
}
.ag-theme-material .ag-icon-row-drag::before {
  content: "\\f116";
}
.ag-theme-material .ag-left-arrow::before {
  content: "\\f119";
}
.ag-theme-material .ag-right-arrow::before {
  content: "\\f128";
}
.ag-theme-material .ag-root-wrapper {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-material [class^=ag-], .ag-theme-material [class^=ag-]:focus, .ag-theme-material [class^=ag-]:after, .ag-theme-material [class^=ag-]:before {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  outline: none;
}
.ag-theme-material [class^=ag-]::-ms-clear {
  display: none;
}
.ag-theme-material .ag-checkbox .ag-input-wrapper,
.ag-theme-material .ag-radio-button .ag-input-wrapper {
  overflow: visible;
}
.ag-theme-material .ag-range-field .ag-input-wrapper {
  height: 100%;
}
.ag-theme-material .ag-toggle-button {
  -webkit-box-flex: 0;
          flex: none;
  width: unset;
  min-width: unset;
}
.ag-theme-material .ag-ltr .ag-label-align-right .ag-label {
  margin-left: 8px;
}

.ag-theme-material .ag-rtl .ag-label-align-right .ag-label {
  margin-right: 8px;
}

.ag-theme-material input[class^=ag-] {
  margin: 0;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-material textarea[class^=ag-],
.ag-theme-material select[class^=ag-] {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-material input[class^=ag-]:not([type]),
.ag-theme-material input[class^=ag-][type=text],
.ag-theme-material input[class^=ag-][type=number],
.ag-theme-material input[class^=ag-][type=tel],
.ag-theme-material input[class^=ag-][type=date],
.ag-theme-material input[class^=ag-][type=datetime-local],
.ag-theme-material textarea[class^=ag-] {
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}
.ag-theme-material input[class^=ag-]:not([type]):disabled,
.ag-theme-material input[class^=ag-][type=text]:disabled,
.ag-theme-material input[class^=ag-][type=number]:disabled,
.ag-theme-material input[class^=ag-][type=tel]:disabled,
.ag-theme-material input[class^=ag-][type=date]:disabled,
.ag-theme-material input[class^=ag-][type=datetime-local]:disabled,
.ag-theme-material textarea[class^=ag-]:disabled {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  background-color: var(--ag-input-disabled-background-color);
  border-color: var(--ag-input-disabled-border-color);
}
.ag-theme-material input[class^=ag-]:not([type]):focus,
.ag-theme-material input[class^=ag-][type=text]:focus,
.ag-theme-material input[class^=ag-][type=number]:focus,
.ag-theme-material input[class^=ag-][type=tel]:focus,
.ag-theme-material input[class^=ag-][type=date]:focus,
.ag-theme-material input[class^=ag-][type=datetime-local]:focus,
.ag-theme-material textarea[class^=ag-]:focus {
  outline: none;
  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material input[class^=ag-]:not([type]):invalid,
.ag-theme-material input[class^=ag-][type=text]:invalid,
.ag-theme-material input[class^=ag-][type=number]:invalid,
.ag-theme-material input[class^=ag-][type=tel]:invalid,
.ag-theme-material input[class^=ag-][type=date]:invalid,
.ag-theme-material input[class^=ag-][type=datetime-local]:invalid,
.ag-theme-material textarea[class^=ag-]:invalid {
  border-width: 2px;
  border-style: solid;
  border-color: var(--ag-input-border-color-invalid);
}
.ag-theme-material input[class^=ag-][type=number] {
  -moz-appearance: textfield;
}
.ag-theme-material input[class^=ag-][type=number]::-webkit-outer-spin-button, .ag-theme-material input[class^=ag-][type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.ag-theme-material input[class^=ag-][type=range] {
  padding: 0;
}
.ag-theme-material input[class^=ag-][type=button]:focus, .ag-theme-material button[class^=ag-]:focus {
  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
}
.ag-theme-material .ag-drag-handle {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-list-item, .ag-theme-material .ag-virtual-list-item {
  height: 32px;
}
.ag-theme-material .ag-keyboard-focus .ag-virtual-list-item:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-select-list {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  overflow-y: auto;
  overflow-x: hidden;
}
.ag-theme-material .ag-list-item {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-theme-material .ag-list-item.ag-active-item {
  background-color: #fafafa;
  background-color: var(--ag-row-hover-color, #fafafa);
}
.ag-theme-material .ag-select-list-item {
  padding-left: 4px;
  padding-right: 4px;
  cursor: default;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.ag-theme-material .ag-select-list-item span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ag-theme-material .ag-select .ag-picker-field-wrapper {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  min-height: 32px;
  cursor: default;
}
.ag-theme-material .ag-select.ag-disabled .ag-picker-field-wrapper:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.ag-theme-material .ag-select:not(.ag-cell-editor) {
  height: 32px;
}
.ag-theme-material .ag-select .ag-picker-field-display {
  margin: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ag-theme-material .ag-select .ag-picker-field-icon {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-material .ag-select.ag-disabled {
  opacity: 0.5;
}
.ag-theme-material .ag-rich-select {
  background-color: #fafafa;
  background-color: var(--ag-control-panel-background-color, #fafafa);
}
.ag-theme-material .ag-rich-select-list {
  width: 100%;
  min-width: 200px;
  height: 312px;
}
.ag-theme-material .ag-rich-select-value {
  padding: 0 8px 0 24px;
  height: 48px;
}
.ag-theme-material .ag-rich-select-virtual-list-item {
  cursor: default;
  height: 32px;
}
.ag-theme-material .ag-rich-select-virtual-list-item:hover {
  background-color: #fafafa;
  background-color: var(--ag-row-hover-color, #fafafa);
}
.ag-theme-material .ag-rich-select-row {
  padding-left: 24px;
}
.ag-theme-material .ag-rich-select-row-selected {
  background-color: #eee;
  background-color: var(--ag-selected-row-background-color, #eee);
}
.ag-theme-material .ag-row-drag,
.ag-theme-material .ag-selection-checkbox,
.ag-theme-material .ag-group-expanded,
.ag-theme-material .ag-group-contracted {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-ltr .ag-row-drag, .ag-theme-material .ag-ltr .ag-selection-checkbox, .ag-theme-material .ag-ltr .ag-group-expanded, .ag-theme-material .ag-ltr .ag-group-contracted {
  margin-right: 24px;
}

.ag-theme-material .ag-rtl .ag-row-drag, .ag-theme-material .ag-rtl .ag-selection-checkbox, .ag-theme-material .ag-rtl .ag-group-expanded, .ag-theme-material .ag-rtl .ag-group-contracted {
  margin-left: 24px;
}

.ag-theme-material .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {
  height: min(var(--ag-line-height, 46px), 46px);
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-flex: 0;
          flex: none;
}
.ag-theme-material .ag-group-expanded,
.ag-theme-material .ag-group-contracted {
  cursor: pointer;
}
.ag-theme-material .ag-group-title-bar-icon {
  cursor: pointer;
  -webkit-box-flex: 0;
          flex: none;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-ltr .ag-group-child-count {
  margin-left: 2px;
}

.ag-theme-material .ag-rtl .ag-group-child-count {
  margin-right: 2px;
}

.ag-theme-material .ag-group-title-bar {
  background-color: #eee;
  background-color: var(--ag-subheader-background-color, #eee);
  padding: 8px;
}
.ag-theme-material .ag-group-toolbar {
  padding: 8px;
}
.ag-theme-material .ag-disabled-group-title-bar, .ag-theme-material .ag-disabled-group-container {
  opacity: 0.5;
}
.ag-theme-material .group-item {
  margin: 4px 0;
}
.ag-theme-material .ag-label {
  white-space: nowrap;
}
.ag-theme-material .ag-ltr .ag-label {
  margin-right: 8px;
}

.ag-theme-material .ag-rtl .ag-label {
  margin-left: 8px;
}

.ag-theme-material .ag-label-align-top .ag-label {
  margin-bottom: 4px;
}
.ag-theme-material .ag-ltr .ag-slider-field, .ag-theme-material .ag-ltr .ag-angle-select-field {
  margin-right: 16px;
}

.ag-theme-material .ag-rtl .ag-slider-field, .ag-theme-material .ag-rtl .ag-angle-select-field {
  margin-left: 16px;
}

.ag-theme-material .ag-angle-select-parent-circle {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: solid 1px;
  border-color: #e2e2e2;
  border-color: var(--ag-border-color, #e2e2e2);
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-material .ag-angle-select-child-circle {
  top: 4px;
  left: 12px;
  width: 6px;
  height: 6px;
  margin-left: -3px;
  margin-top: -4px;
  border-radius: 3px;
  background-color: rgba(0, 0, 0, 0.54);
  background-color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-picker-field-wrapper {
  border: 1px solid;
  border-color: #e2e2e2;
  border-color: var(--ag-border-color, #e2e2e2);
  border-radius: 5px;
}
.ag-theme-material .ag-picker-field-wrapper:focus {
  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
}
.ag-theme-material .ag-picker-field-button {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-dialog.ag-color-dialog {
  border-radius: 5px;
}
.ag-theme-material .ag-color-picker .ag-picker-field-display {
  height: 18px;
}
.ag-theme-material .ag-color-panel {
  padding: 8px;
}
.ag-theme-material .ag-spectrum-color {
  background-color: rgb(255, 0, 0);
  border-radius: 2px;
}
.ag-theme-material .ag-spectrum-tools {
  padding: 10px;
}
.ag-theme-material .ag-spectrum-sat {
  background-image: -webkit-gradient(linear, left top, right top, from(white), to(rgba(204, 154, 129, 0)));
  background-image: linear-gradient(to right, white, rgba(204, 154, 129, 0));
}
.ag-theme-material .ag-spectrum-val {
  background-image: -webkit-gradient(linear, left bottom, left top, from(black), to(rgba(204, 154, 129, 0)));
  background-image: linear-gradient(to top, black, rgba(204, 154, 129, 0));
}
.ag-theme-material .ag-spectrum-dragger {
  border-radius: 12px;
  height: 12px;
  width: 12px;
  border: 1px solid white;
  background: black;
  -webkit-box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);
          box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);
}
.ag-theme-material .ag-spectrum-hue-background {
  border-radius: 2px;
}
.ag-theme-material .ag-spectrum-alpha-background {
  border-radius: 2px;
}
.ag-theme-material .ag-spectrum-tool {
  margin-bottom: 10px;
  height: 11px;
  border-radius: 2px;
}
.ag-theme-material .ag-spectrum-slider {
  margin-top: -12px;
  width: 13px;
  height: 13px;
  border-radius: 13px;
  background-color: rgb(248, 248, 248);
  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);
}
.ag-theme-material .ag-recent-color {
  margin: 0 3px;
}
.ag-theme-material .ag-recent-color:first-child {
  margin-left: 0;
}
.ag-theme-material .ag-recent-color:last-child {
  margin-right: 0;
}
.ag-theme-material.ag-dnd-ghost {
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 2px;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
  height: 56px !important;
  line-height: 56px;
  margin: 0;
  padding: 0 16px;
  -webkit-transform: translateY(16px);
          transform: translateY(16px);
}
.ag-theme-material .ag-dnd-ghost-icon {
  margin-right: 8px;
  color: rgba(0, 0, 0, 0.87);
  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));
}
.ag-theme-material .ag-popup-child:not(.ag-tooltip-custom) {
  -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
}
.ag-dragging-range-handle .ag-theme-material .ag-dialog, .ag-dragging-fill-handle .ag-theme-material .ag-dialog {
  opacity: 0.7;
  pointer-events: none;
}
.ag-theme-material .ag-dialog {
  border-radius: 0px;
}
.ag-theme-material .ag-panel {
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-material .ag-panel-title-bar {
  background-color: #fff;
  background-color: var(--ag-header-background-color, #fff);
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));
  height: 56px;
  padding: 8px 24px;
}
.ag-theme-material .ag-ltr .ag-panel-title-bar-button {
  margin-left: 8px;
}

.ag-theme-material .ag-rtl .ag-panel-title-bar-button {
  margin-right: 8px;
}

.ag-theme-material .ag-tooltip {
  background-color: #fff;
  background-color: var(--ag-header-background-color, #fff);
  color: rgba(0, 0, 0, 0.87);
  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));
  padding: 8px;
  border-radius: 2px;
  -webkit-transition: opacity 1s;
  transition: opacity 1s;
  white-space: normal;
}
.ag-theme-material .ag-tooltip.ag-tooltip-hiding {
  opacity: 0;
}
.ag-theme-material .ag-tooltip-custom {
  -webkit-transition: opacity 1s;
  transition: opacity 1s;
}
.ag-theme-material .ag-tooltip-custom.ag-tooltip-hiding {
  opacity: 0;
}
.ag-theme-material .ag-ltr .ag-column-select-indent-1 {
  padding-left: 26px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-1 {
  padding-right: 26px;
}

.ag-theme-material .ag-ltr .ag-column-select-indent-2 {
  padding-left: 52px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-2 {
  padding-right: 52px;
}

.ag-theme-material .ag-ltr .ag-column-select-indent-3 {
  padding-left: 78px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-3 {
  padding-right: 78px;
}

.ag-theme-material .ag-ltr .ag-column-select-indent-4 {
  padding-left: 104px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-4 {
  padding-right: 104px;
}

.ag-theme-material .ag-ltr .ag-column-select-indent-5 {
  padding-left: 130px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-5 {
  padding-right: 130px;
}

.ag-theme-material .ag-ltr .ag-column-select-indent-6 {
  padding-left: 156px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-6 {
  padding-right: 156px;
}

.ag-theme-material .ag-ltr .ag-column-select-indent-7 {
  padding-left: 182px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-7 {
  padding-right: 182px;
}

.ag-theme-material .ag-ltr .ag-column-select-indent-8 {
  padding-left: 208px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-8 {
  padding-right: 208px;
}

.ag-theme-material .ag-ltr .ag-column-select-indent-9 {
  padding-left: 234px;
}

.ag-theme-material .ag-rtl .ag-column-select-indent-9 {
  padding-right: 234px;
}

.ag-theme-material .ag-column-select-header-icon {
  cursor: pointer;
}
.ag-theme-material .ag-keyboard-focus .ag-column-select-header-icon:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-column-select-header-icon:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 0px;
  left: 0px;
  display: block;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-ltr .ag-column-group-icons:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-header-icon:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-header-checkbox:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-checkbox:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-column-label:not(:last-child) {
  margin-right: 16px;
}

.ag-theme-material .ag-rtl .ag-column-group-icons:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-header-icon:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-header-checkbox:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-checkbox:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-column-label:not(:last-child) {
  margin-left: 16px;
}

.ag-theme-material .ag-keyboard-focus .ag-column-select-virtual-list-item:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-column-select-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-column-select-column-group:not(:last-child),
.ag-theme-material .ag-column-select-column:not(:last-child) {
  margin-bottom: 14px;
}
.ag-theme-material .ag-column-select-column-readonly,
.ag-theme-material .ag-column-select-column-group-readonly {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  pointer-events: none;
}
.ag-theme-material .ag-ltr .ag-column-select-add-group-indent {
  margin-left: 34px;
}

.ag-theme-material .ag-rtl .ag-column-select-add-group-indent {
  margin-right: 34px;
}

.ag-theme-material .ag-column-select-virtual-list-viewport {
  padding: 8px 0px;
}
.ag-theme-material .ag-column-select-virtual-list-item {
  padding: 0 12px;
}
.ag-theme-material .ag-rtl {
  text-align: right;
}
.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {
  padding-left: 66px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {
  padding-right: 66px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-1 {
  padding-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-1 {
  padding-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {
  padding-left: 108px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {
  padding-right: 108px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-2 {
  padding-left: 84px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-2 {
  padding-right: 84px;
}

.ag-theme-material .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {
  padding-left: 150px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {
  padding-right: 150px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-3 {
  padding-left: 126px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-3 {
  padding-right: 126px;
}

.ag-theme-material .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {
  padding-left: 192px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {
  padding-right: 192px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-4 {
  padding-left: 168px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-4 {
  padding-right: 168px;
}

.ag-theme-material .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {
  padding-left: 234px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {
  padding-right: 234px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-5 {
  padding-left: 210px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-5 {
  padding-right: 210px;
}

.ag-theme-material .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {
  padding-left: 276px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {
  padding-right: 276px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-6 {
  padding-left: 252px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-6 {
  padding-right: 252px;
}

.ag-theme-material .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {
  padding-left: 318px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {
  padding-right: 318px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-7 {
  padding-left: 294px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-7 {
  padding-right: 294px;
}

.ag-theme-material .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {
  padding-left: 360px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {
  padding-right: 360px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-8 {
  padding-left: 336px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-8 {
  padding-right: 336px;
}

.ag-theme-material .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {
  padding-left: 402px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {
  padding-right: 402px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-9 {
  padding-left: 378px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-9 {
  padding-right: 378px;
}

.ag-theme-material .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {
  padding-left: 444px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {
  padding-right: 444px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-10 {
  padding-left: 420px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-10 {
  padding-right: 420px;
}

.ag-theme-material .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {
  padding-left: 486px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {
  padding-right: 486px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-11 {
  padding-left: 462px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-11 {
  padding-right: 462px;
}

.ag-theme-material .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {
  padding-left: 528px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {
  padding-right: 528px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-12 {
  padding-left: 504px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-12 {
  padding-right: 504px;
}

.ag-theme-material .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {
  padding-left: 570px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {
  padding-right: 570px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-13 {
  padding-left: 546px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-13 {
  padding-right: 546px;
}

.ag-theme-material .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {
  padding-left: 612px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {
  padding-right: 612px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-14 {
  padding-left: 588px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-14 {
  padding-right: 588px;
}

.ag-theme-material .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {
  padding-left: 654px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {
  padding-right: 654px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-15 {
  padding-left: 630px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-15 {
  padding-right: 630px;
}

.ag-theme-material .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {
  padding-left: 696px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {
  padding-right: 696px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-16 {
  padding-left: 672px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-16 {
  padding-right: 672px;
}

.ag-theme-material .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {
  padding-left: 738px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {
  padding-right: 738px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-17 {
  padding-left: 714px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-17 {
  padding-right: 714px;
}

.ag-theme-material .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {
  padding-left: 780px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {
  padding-right: 780px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-18 {
  padding-left: 756px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-18 {
  padding-right: 756px;
}

.ag-theme-material .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {
  padding-left: 822px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {
  padding-right: 822px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-19 {
  padding-left: 798px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-19 {
  padding-right: 798px;
}

.ag-theme-material .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {
  padding-left: 864px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {
  padding-right: 864px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-20 {
  padding-left: 840px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-20 {
  padding-right: 840px;
}

.ag-theme-material .ag-ltr .ag-row-level-20 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-20 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {
  padding-left: 906px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {
  padding-right: 906px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-21 {
  padding-left: 882px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-21 {
  padding-right: 882px;
}

.ag-theme-material .ag-ltr .ag-row-level-21 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-21 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {
  padding-left: 948px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {
  padding-right: 948px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-22 {
  padding-left: 924px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-22 {
  padding-right: 924px;
}

.ag-theme-material .ag-ltr .ag-row-level-22 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-22 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {
  padding-left: 990px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {
  padding-right: 990px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-23 {
  padding-left: 966px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-23 {
  padding-right: 966px;
}

.ag-theme-material .ag-ltr .ag-row-level-23 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-23 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {
  padding-left: 1032px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {
  padding-right: 1032px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-24 {
  padding-left: 1008px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-24 {
  padding-right: 1008px;
}

.ag-theme-material .ag-ltr .ag-row-level-24 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-24 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {
  padding-left: 1074px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {
  padding-right: 1074px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-25 {
  padding-left: 1050px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-25 {
  padding-right: 1050px;
}

.ag-theme-material .ag-ltr .ag-row-level-25 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-25 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {
  padding-left: 1116px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {
  padding-right: 1116px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-26 {
  padding-left: 1092px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-26 {
  padding-right: 1092px;
}

.ag-theme-material .ag-ltr .ag-row-level-26 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-26 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {
  padding-left: 1158px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {
  padding-right: 1158px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-27 {
  padding-left: 1134px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-27 {
  padding-right: 1134px;
}

.ag-theme-material .ag-ltr .ag-row-level-27 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-27 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {
  padding-left: 1200px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {
  padding-right: 1200px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-28 {
  padding-left: 1176px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-28 {
  padding-right: 1176px;
}

.ag-theme-material .ag-ltr .ag-row-level-28 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-28 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {
  padding-left: 1242px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {
  padding-right: 1242px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-29 {
  padding-left: 1218px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-29 {
  padding-right: 1218px;
}

.ag-theme-material .ag-ltr .ag-row-level-29 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-29 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {
  padding-left: 1284px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {
  padding-right: 1284px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-30 {
  padding-left: 1260px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-30 {
  padding-right: 1260px;
}

.ag-theme-material .ag-ltr .ag-row-level-30 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-30 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {
  padding-left: 1326px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {
  padding-right: 1326px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-31 {
  padding-left: 1302px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-31 {
  padding-right: 1302px;
}

.ag-theme-material .ag-ltr .ag-row-level-31 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-31 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {
  padding-left: 1368px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {
  padding-right: 1368px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-32 {
  padding-left: 1344px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-32 {
  padding-right: 1344px;
}

.ag-theme-material .ag-ltr .ag-row-level-32 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-32 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {
  padding-left: 1410px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {
  padding-right: 1410px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-33 {
  padding-left: 1386px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-33 {
  padding-right: 1386px;
}

.ag-theme-material .ag-ltr .ag-row-level-33 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-33 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {
  padding-left: 1452px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {
  padding-right: 1452px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-34 {
  padding-left: 1428px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-34 {
  padding-right: 1428px;
}

.ag-theme-material .ag-ltr .ag-row-level-34 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-34 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {
  padding-left: 1494px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {
  padding-right: 1494px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-35 {
  padding-left: 1470px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-35 {
  padding-right: 1470px;
}

.ag-theme-material .ag-ltr .ag-row-level-35 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-35 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {
  padding-left: 1536px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {
  padding-right: 1536px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-36 {
  padding-left: 1512px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-36 {
  padding-right: 1512px;
}

.ag-theme-material .ag-ltr .ag-row-level-36 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-36 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {
  padding-left: 1578px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {
  padding-right: 1578px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-37 {
  padding-left: 1554px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-37 {
  padding-right: 1554px;
}

.ag-theme-material .ag-ltr .ag-row-level-37 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-37 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {
  padding-left: 1620px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {
  padding-right: 1620px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-38 {
  padding-left: 1596px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-38 {
  padding-right: 1596px;
}

.ag-theme-material .ag-ltr .ag-row-level-38 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-38 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {
  padding-left: 1662px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {
  padding-right: 1662px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-39 {
  padding-left: 1638px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-39 {
  padding-right: 1638px;
}

.ag-theme-material .ag-ltr .ag-row-level-39 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-39 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {
  padding-left: 1704px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {
  padding-right: 1704px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-40 {
  padding-left: 1680px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-40 {
  padding-right: 1680px;
}

.ag-theme-material .ag-ltr .ag-row-level-40 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-40 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {
  padding-left: 1746px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {
  padding-right: 1746px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-41 {
  padding-left: 1722px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-41 {
  padding-right: 1722px;
}

.ag-theme-material .ag-ltr .ag-row-level-41 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-41 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {
  padding-left: 1788px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {
  padding-right: 1788px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-42 {
  padding-left: 1764px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-42 {
  padding-right: 1764px;
}

.ag-theme-material .ag-ltr .ag-row-level-42 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-42 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {
  padding-left: 1830px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {
  padding-right: 1830px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-43 {
  padding-left: 1806px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-43 {
  padding-right: 1806px;
}

.ag-theme-material .ag-ltr .ag-row-level-43 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-43 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {
  padding-left: 1872px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {
  padding-right: 1872px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-44 {
  padding-left: 1848px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-44 {
  padding-right: 1848px;
}

.ag-theme-material .ag-ltr .ag-row-level-44 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-44 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {
  padding-left: 1914px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {
  padding-right: 1914px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-45 {
  padding-left: 1890px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-45 {
  padding-right: 1890px;
}

.ag-theme-material .ag-ltr .ag-row-level-45 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-45 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {
  padding-left: 1956px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {
  padding-right: 1956px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-46 {
  padding-left: 1932px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-46 {
  padding-right: 1932px;
}

.ag-theme-material .ag-ltr .ag-row-level-46 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-46 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {
  padding-left: 1998px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {
  padding-right: 1998px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-47 {
  padding-left: 1974px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-47 {
  padding-right: 1974px;
}

.ag-theme-material .ag-ltr .ag-row-level-47 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-47 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {
  padding-left: 2040px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {
  padding-right: 2040px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-48 {
  padding-left: 2016px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-48 {
  padding-right: 2016px;
}

.ag-theme-material .ag-ltr .ag-row-level-48 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-48 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {
  padding-left: 2082px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {
  padding-right: 2082px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-49 {
  padding-left: 2058px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-49 {
  padding-right: 2058px;
}

.ag-theme-material .ag-ltr .ag-row-level-49 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-49 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {
  padding-left: 2124px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {
  padding-right: 2124px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-50 {
  padding-left: 2100px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-50 {
  padding-right: 2100px;
}

.ag-theme-material .ag-ltr .ag-row-level-50 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-50 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {
  padding-left: 2166px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {
  padding-right: 2166px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-51 {
  padding-left: 2142px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-51 {
  padding-right: 2142px;
}

.ag-theme-material .ag-ltr .ag-row-level-51 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-51 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {
  padding-left: 2208px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {
  padding-right: 2208px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-52 {
  padding-left: 2184px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-52 {
  padding-right: 2184px;
}

.ag-theme-material .ag-ltr .ag-row-level-52 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-52 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {
  padding-left: 2250px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {
  padding-right: 2250px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-53 {
  padding-left: 2226px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-53 {
  padding-right: 2226px;
}

.ag-theme-material .ag-ltr .ag-row-level-53 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-53 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {
  padding-left: 2292px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {
  padding-right: 2292px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-54 {
  padding-left: 2268px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-54 {
  padding-right: 2268px;
}

.ag-theme-material .ag-ltr .ag-row-level-54 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-54 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {
  padding-left: 2334px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {
  padding-right: 2334px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-55 {
  padding-left: 2310px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-55 {
  padding-right: 2310px;
}

.ag-theme-material .ag-ltr .ag-row-level-55 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-55 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {
  padding-left: 2376px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {
  padding-right: 2376px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-56 {
  padding-left: 2352px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-56 {
  padding-right: 2352px;
}

.ag-theme-material .ag-ltr .ag-row-level-56 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-56 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {
  padding-left: 2418px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {
  padding-right: 2418px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-57 {
  padding-left: 2394px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-57 {
  padding-right: 2394px;
}

.ag-theme-material .ag-ltr .ag-row-level-57 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-57 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {
  padding-left: 2460px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {
  padding-right: 2460px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-58 {
  padding-left: 2436px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-58 {
  padding-right: 2436px;
}

.ag-theme-material .ag-ltr .ag-row-level-58 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-58 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {
  padding-left: 2502px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {
  padding-right: 2502px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-59 {
  padding-left: 2478px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-59 {
  padding-right: 2478px;
}

.ag-theme-material .ag-ltr .ag-row-level-59 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-59 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {
  padding-left: 2544px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {
  padding-right: 2544px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-60 {
  padding-left: 2520px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-60 {
  padding-right: 2520px;
}

.ag-theme-material .ag-ltr .ag-row-level-60 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-60 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {
  padding-left: 2586px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {
  padding-right: 2586px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-61 {
  padding-left: 2562px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-61 {
  padding-right: 2562px;
}

.ag-theme-material .ag-ltr .ag-row-level-61 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-61 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {
  padding-left: 2628px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {
  padding-right: 2628px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-62 {
  padding-left: 2604px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-62 {
  padding-right: 2604px;
}

.ag-theme-material .ag-ltr .ag-row-level-62 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-62 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {
  padding-left: 2670px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {
  padding-right: 2670px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-63 {
  padding-left: 2646px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-63 {
  padding-right: 2646px;
}

.ag-theme-material .ag-ltr .ag-row-level-63 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-63 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {
  padding-left: 2712px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {
  padding-right: 2712px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-64 {
  padding-left: 2688px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-64 {
  padding-right: 2688px;
}

.ag-theme-material .ag-ltr .ag-row-level-64 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-64 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {
  padding-left: 2754px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {
  padding-right: 2754px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-65 {
  padding-left: 2730px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-65 {
  padding-right: 2730px;
}

.ag-theme-material .ag-ltr .ag-row-level-65 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-65 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {
  padding-left: 2796px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {
  padding-right: 2796px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-66 {
  padding-left: 2772px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-66 {
  padding-right: 2772px;
}

.ag-theme-material .ag-ltr .ag-row-level-66 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-66 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {
  padding-left: 2838px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {
  padding-right: 2838px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-67 {
  padding-left: 2814px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-67 {
  padding-right: 2814px;
}

.ag-theme-material .ag-ltr .ag-row-level-67 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-67 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {
  padding-left: 2880px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {
  padding-right: 2880px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-68 {
  padding-left: 2856px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-68 {
  padding-right: 2856px;
}

.ag-theme-material .ag-ltr .ag-row-level-68 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-68 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {
  padding-left: 2922px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {
  padding-right: 2922px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-69 {
  padding-left: 2898px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-69 {
  padding-right: 2898px;
}

.ag-theme-material .ag-ltr .ag-row-level-69 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-69 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {
  padding-left: 2964px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {
  padding-right: 2964px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-70 {
  padding-left: 2940px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-70 {
  padding-right: 2940px;
}

.ag-theme-material .ag-ltr .ag-row-level-70 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-70 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {
  padding-left: 3006px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {
  padding-right: 3006px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-71 {
  padding-left: 2982px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-71 {
  padding-right: 2982px;
}

.ag-theme-material .ag-ltr .ag-row-level-71 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-71 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {
  padding-left: 3048px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {
  padding-right: 3048px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-72 {
  padding-left: 3024px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-72 {
  padding-right: 3024px;
}

.ag-theme-material .ag-ltr .ag-row-level-72 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-72 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {
  padding-left: 3090px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {
  padding-right: 3090px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-73 {
  padding-left: 3066px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-73 {
  padding-right: 3066px;
}

.ag-theme-material .ag-ltr .ag-row-level-73 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-73 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {
  padding-left: 3132px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {
  padding-right: 3132px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-74 {
  padding-left: 3108px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-74 {
  padding-right: 3108px;
}

.ag-theme-material .ag-ltr .ag-row-level-74 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-74 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {
  padding-left: 3174px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {
  padding-right: 3174px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-75 {
  padding-left: 3150px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-75 {
  padding-right: 3150px;
}

.ag-theme-material .ag-ltr .ag-row-level-75 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-75 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {
  padding-left: 3216px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {
  padding-right: 3216px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-76 {
  padding-left: 3192px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-76 {
  padding-right: 3192px;
}

.ag-theme-material .ag-ltr .ag-row-level-76 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-76 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {
  padding-left: 3258px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {
  padding-right: 3258px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-77 {
  padding-left: 3234px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-77 {
  padding-right: 3234px;
}

.ag-theme-material .ag-ltr .ag-row-level-77 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-77 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {
  padding-left: 3300px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {
  padding-right: 3300px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-78 {
  padding-left: 3276px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-78 {
  padding-right: 3276px;
}

.ag-theme-material .ag-ltr .ag-row-level-78 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-78 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {
  padding-left: 3342px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {
  padding-right: 3342px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-79 {
  padding-left: 3318px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-79 {
  padding-right: 3318px;
}

.ag-theme-material .ag-ltr .ag-row-level-79 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-79 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {
  padding-left: 3384px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {
  padding-right: 3384px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-80 {
  padding-left: 3360px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-80 {
  padding-right: 3360px;
}

.ag-theme-material .ag-ltr .ag-row-level-80 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-80 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {
  padding-left: 3426px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {
  padding-right: 3426px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-81 {
  padding-left: 3402px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-81 {
  padding-right: 3402px;
}

.ag-theme-material .ag-ltr .ag-row-level-81 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-81 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {
  padding-left: 3468px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {
  padding-right: 3468px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-82 {
  padding-left: 3444px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-82 {
  padding-right: 3444px;
}

.ag-theme-material .ag-ltr .ag-row-level-82 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-82 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {
  padding-left: 3510px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {
  padding-right: 3510px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-83 {
  padding-left: 3486px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-83 {
  padding-right: 3486px;
}

.ag-theme-material .ag-ltr .ag-row-level-83 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-83 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {
  padding-left: 3552px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {
  padding-right: 3552px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-84 {
  padding-left: 3528px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-84 {
  padding-right: 3528px;
}

.ag-theme-material .ag-ltr .ag-row-level-84 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-84 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {
  padding-left: 3594px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {
  padding-right: 3594px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-85 {
  padding-left: 3570px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-85 {
  padding-right: 3570px;
}

.ag-theme-material .ag-ltr .ag-row-level-85 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-85 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {
  padding-left: 3636px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {
  padding-right: 3636px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-86 {
  padding-left: 3612px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-86 {
  padding-right: 3612px;
}

.ag-theme-material .ag-ltr .ag-row-level-86 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-86 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {
  padding-left: 3678px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {
  padding-right: 3678px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-87 {
  padding-left: 3654px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-87 {
  padding-right: 3654px;
}

.ag-theme-material .ag-ltr .ag-row-level-87 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-87 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {
  padding-left: 3720px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {
  padding-right: 3720px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-88 {
  padding-left: 3696px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-88 {
  padding-right: 3696px;
}

.ag-theme-material .ag-ltr .ag-row-level-88 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-88 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {
  padding-left: 3762px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {
  padding-right: 3762px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-89 {
  padding-left: 3738px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-89 {
  padding-right: 3738px;
}

.ag-theme-material .ag-ltr .ag-row-level-89 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-89 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {
  padding-left: 3804px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {
  padding-right: 3804px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-90 {
  padding-left: 3780px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-90 {
  padding-right: 3780px;
}

.ag-theme-material .ag-ltr .ag-row-level-90 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-90 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {
  padding-left: 3846px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {
  padding-right: 3846px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-91 {
  padding-left: 3822px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-91 {
  padding-right: 3822px;
}

.ag-theme-material .ag-ltr .ag-row-level-91 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-91 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {
  padding-left: 3888px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {
  padding-right: 3888px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-92 {
  padding-left: 3864px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-92 {
  padding-right: 3864px;
}

.ag-theme-material .ag-ltr .ag-row-level-92 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-92 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {
  padding-left: 3930px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {
  padding-right: 3930px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-93 {
  padding-left: 3906px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-93 {
  padding-right: 3906px;
}

.ag-theme-material .ag-ltr .ag-row-level-93 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-93 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {
  padding-left: 3972px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {
  padding-right: 3972px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-94 {
  padding-left: 3948px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-94 {
  padding-right: 3948px;
}

.ag-theme-material .ag-ltr .ag-row-level-94 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-94 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {
  padding-left: 4014px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {
  padding-right: 4014px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-95 {
  padding-left: 3990px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-95 {
  padding-right: 3990px;
}

.ag-theme-material .ag-ltr .ag-row-level-95 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-95 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {
  padding-left: 4056px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {
  padding-right: 4056px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-96 {
  padding-left: 4032px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-96 {
  padding-right: 4032px;
}

.ag-theme-material .ag-ltr .ag-row-level-96 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-96 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {
  padding-left: 4098px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {
  padding-right: 4098px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-97 {
  padding-left: 4074px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-97 {
  padding-right: 4074px;
}

.ag-theme-material .ag-ltr .ag-row-level-97 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-97 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {
  padding-left: 4140px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {
  padding-right: 4140px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-98 {
  padding-left: 4116px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-98 {
  padding-right: 4116px;
}

.ag-theme-material .ag-ltr .ag-row-level-98 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-98 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {
  padding-left: 4182px;
}

.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {
  padding-right: 4182px;
}

.ag-theme-material .ag-ltr .ag-row-group-indent-99 {
  padding-left: 4158px;
}

.ag-theme-material .ag-rtl .ag-row-group-indent-99 {
  padding-right: 4158px;
}

.ag-theme-material .ag-ltr .ag-row-level-99 .ag-pivot-leaf-group {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-level-99 .ag-pivot-leaf-group {
  margin-right: 42px;
}

.ag-theme-material .ag-ltr .ag-row-group-leaf-indent {
  margin-left: 42px;
}

.ag-theme-material .ag-rtl .ag-row-group-leaf-indent {
  margin-right: 42px;
}

.ag-theme-material .ag-value-change-delta {
  padding-right: 2px;
}
.ag-theme-material .ag-value-change-delta-up {
  color: #43a047;
  color: var(--ag-value-change-delta-up-color, #43a047);
}
.ag-theme-material .ag-value-change-delta-down {
  color: #e53935;
  color: var(--ag-value-change-delta-down-color, #e53935);
}
.ag-theme-material .ag-value-change-value {
  background-color: transparent;
  border-radius: 1px;
  padding-left: 1px;
  padding-right: 1px;
  -webkit-transition: background-color 1s;
  transition: background-color 1s;
}
.ag-theme-material .ag-value-change-value-highlight {
  background-color: #00acc1;
  background-color: var(--ag-value-change-value-highlight-background-color, #00acc1);
  -webkit-transition: background-color 0.1s;
  transition: background-color 0.1s;
}
.ag-theme-material .ag-cell-data-changed {
  background-color: #00acc1 !important;
  background-color: var(--ag-value-change-value-highlight-background-color, #00acc1) !important;
}
.ag-theme-material .ag-cell-data-changed-animation {
  background-color: transparent;
}
.ag-theme-material .ag-cell-highlight {
  background-color: #fce4ec !important;
  background-color: var(--ag-range-selection-highlight-color, #fce4ec) !important;
}
.ag-theme-material .ag-row {
  height: 48px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  color: rgba(0, 0, 0, 0.87);
  color: var(--ag-data-color, var(--ag-foreground-color, rgba(0, 0, 0, 0.87)));
  border-width: 1px;
  border-color: #e2e2e2;
  border-color: var(--ag-row-border-color, var(--ag-secondary-border-color, var(--ag-border-color, #e2e2e2)));
  border-bottom-style: solid;
}
.ag-theme-material .ag-row-highlight-above::after, .ag-theme-material .ag-row-highlight-below::after {
  content: "";
  position: absolute;
  width: calc(100% - 1px);
  height: 1px;
  background-color: #3f51b5;
  background-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
  left: 1px;
}
.ag-theme-material .ag-row-highlight-above::after {
  top: -1px;
}
.ag-theme-material .ag-row-highlight-above.ag-row-first::after {
  top: 0;
}
.ag-theme-material .ag-row-highlight-below::after {
  bottom: 0px;
}
.ag-theme-material .ag-row-odd {
  background-color: var(--ag-odd-row-background-color);
}
.ag-theme-material .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {
  border-right: solid 1px;
  border-right-color: #e2e2e2;
  border-right-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {
  border-left: solid 1px;
  border-left-color: #e2e2e2;
  border-left-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-row-hover {
  background-color: #fafafa;
  background-color: var(--ag-row-hover-color, #fafafa);
}
.ag-theme-material .ag-column-hover {
  background-color: #fafafa;
  background-color: var(--ag-column-hover-color, #fafafa);
}
.ag-theme-material .ag-ltr .ag-right-aligned-cell {
  text-align: right;
}

.ag-theme-material .ag-rtl .ag-right-aligned-cell {
  text-align: left;
}

.ag-theme-material .ag-ltr .ag-right-aligned-cell .ag-cell-value, .ag-theme-material .ag-ltr .ag-right-aligned-cell .ag-group-value {
  margin-left: auto;
}

.ag-theme-material .ag-rtl .ag-right-aligned-cell .ag-cell-value, .ag-theme-material .ag-rtl .ag-right-aligned-cell .ag-group-value {
  margin-right: auto;
}

.ag-theme-material .ag-cell, .ag-theme-material .ag-full-width-row .ag-cell-wrapper.ag-row-group {
  border: 1px solid transparent;
  line-height: min(var(--ag-line-height, 46px), 46px);
  padding-left: 23px;
  padding-right: 23px;
  -webkit-font-smoothing: subpixel-antialiased;
}
.ag-theme-material .ag-row > .ag-cell-wrapper {
  padding-left: 23px;
  padding-right: 23px;
}
.ag-theme-material .ag-row-dragging {
  cursor: move;
  opacity: 0.5;
}
.ag-theme-material .ag-cell-inline-editing {
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 2px;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
  padding: 0;
  height: 48px;
  background-color: #fafafa;
  background-color: var(--ag-control-panel-background-color, #fafafa);
}
.ag-theme-material .ag-popup-editor {
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 2px;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
  background-color: #fafafa;
  background-color: var(--ag-control-panel-background-color, #fafafa);
  padding: 0;
}
.ag-theme-material .ag-large-text-input {
  height: auto;
  padding: 24px;
}
.ag-theme-material .ag-details-row {
  padding: 40px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
}
.ag-theme-material .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-material .ag-layout-auto-height .ag-center-cols-container, .ag-theme-material .ag-layout-print .ag-center-cols-clipper, .ag-theme-material .ag-layout-print .ag-center-cols-container {
  min-height: 50px;
}
.ag-theme-material .ag-overlay-loading-wrapper {
  background-color: rgba(255, 255, 255, 0.66);
  background-color: var(--ag-modal-overlay-background-color, rgba(255, 255, 255, 0.66));
}
.ag-theme-material .ag-overlay-loading-center {
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 2px;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
}
.ag-theme-material .ag-overlay-no-rows-wrapper.ag-layout-auto-height {
  padding-top: 30px;
}
.ag-theme-material .ag-loading {
  padding-left: 24px;
  display: -webkit-box;
  display: flex;
  height: 100%;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-material .ag-loading-icon {
  padding-right: 24px;
}
.ag-theme-material .ag-icon-loading {
  -webkit-animation-name: spin;
          animation-name: spin;
  -webkit-animation-duration: 1000ms;
          animation-duration: 1000ms;
  -webkit-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
          animation-timing-function: linear;
}
@-webkit-keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes spin {
  from {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.ag-theme-material .ag-floating-top {
  border-bottom: solid 1px;
  border-bottom-color: #e2e2e2;
  border-bottom-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-floating-bottom {
  border-top: solid 1px;
  border-top-color: #e2e2e2;
  border-top-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-ltr .ag-cell {
  border-right: solid transparent;
}

.ag-theme-material .ag-rtl .ag-cell {
  border-left: solid transparent;
}

.ag-theme-material .ag-ltr .ag-cell {
  border-right-width: 1px;
}

.ag-theme-material .ag-rtl .ag-cell {
  border-left-width: 1px;
}

.ag-theme-material .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {
  border-left: solid 1px;
  border-left-color: #e2e2e2;
  border-left-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {
  border-right: solid 1px;
  border-right-color: #e2e2e2;
  border-right-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-row-selected {
  background-color: #eee;
  background-color: var(--ag-selected-row-background-color, #eee);
}
.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus),
.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {
  background-color: rgba(122, 134, 203, 0.1);
  background-color: var(--ag-range-selection-background-color, rgba(122, 134, 203, 0.1));
}
.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,
.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {
  background-color: rgba(0, 88, 255, 0.1) !important;
  background-color: var(--ag-range-selection-chart-background-color, rgba(0, 88, 255, 0.1)) !important;
}
.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,
.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {
  background-color: rgba(0, 255, 132, 0.1) !important;
  background-color: var(--ag-range-selection-chart-category-background-color, rgba(0, 255, 132, 0.1)) !important;
}
.ag-theme-material .ag-cell-range-selected-1:not(.ag-cell-focus),
.ag-theme-material .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {
  background-color: rgba(122, 134, 203, 0.1);
  background-color: var(--ag-range-selection-background-color-1, var(--ag-range-selection-background-color, rgba(122, 134, 203, 0.1)));
}
.ag-theme-material .ag-cell-range-selected-2:not(.ag-cell-focus),
.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {
  background-color: rgba(122, 134, 203, 0.19);
  background-color: var(--ag-range-selection-background-color-2, rgba(122, 134, 203, 0.19));
}
.ag-theme-material .ag-cell-range-selected-3:not(.ag-cell-focus),
.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {
  background-color: rgba(122, 134, 203, 0.271);
  background-color: var(--ag-range-selection-background-color-3, rgba(122, 134, 203, 0.271));
}
.ag-theme-material .ag-cell-range-selected-4:not(.ag-cell-focus),
.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {
  background-color: rgba(122, 134, 203, 0.3439);
  background-color: var(--ag-range-selection-background-color-4, rgba(122, 134, 203, 0.3439));
}
.ag-theme-material .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {
  border-top-color: #3f51b5;
  border-top-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {
  border-right-color: #3f51b5;
  border-right-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {
  border-bottom-color: #3f51b5;
  border-bottom-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {
  border-left-color: #3f51b5;
  border-left-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-material .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-material .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,
.ag-theme-material .ag-ltr .ag-cell-range-single-cell,
.ag-theme-material .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle, .ag-theme-material .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-material .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),
.ag-theme-material .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,
.ag-theme-material .ag-rtl .ag-cell-range-single-cell,
.ag-theme-material .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
  outline: initial;
}
.ag-theme-material .ag-cell.ag-selection-fill-top,
.ag-theme-material .ag-cell.ag-selection-fill-top.ag-cell-range-selected {
  border-top: 1px dashed;
  border-top-color: #3f51b5;
  border-top-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-ltr .ag-cell.ag-selection-fill-right, .ag-theme-material .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected {
  border-right: 1px dashed;
  border-right-color: #3f51b5;
  border-right-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}

.ag-theme-material .ag-rtl .ag-cell.ag-selection-fill-right, .ag-theme-material .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected {
  border-left: 1px dashed;
  border-left-color: #3f51b5;
  border-left-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}

.ag-theme-material .ag-cell.ag-selection-fill-bottom,
.ag-theme-material .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected {
  border-bottom: 1px dashed;
  border-bottom-color: #3f51b5;
  border-bottom-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-ltr .ag-cell.ag-selection-fill-left, .ag-theme-material .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected {
  border-left: 1px dashed;
  border-left-color: #3f51b5;
  border-left-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}

.ag-theme-material .ag-rtl .ag-cell.ag-selection-fill-left, .ag-theme-material .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected {
  border-right: 1px dashed;
  border-right-color: #3f51b5;
  border-right-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}

.ag-theme-material .ag-range-handle, .ag-theme-material .ag-fill-handle {
  position: absolute;
  width: 6px;
  height: 6px;
  bottom: -1px;
  background-color: #3f51b5;
  background-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-ltr .ag-range-handle, .ag-theme-material .ag-ltr .ag-fill-handle {
  right: -1px;
}

.ag-theme-material .ag-rtl .ag-range-handle, .ag-theme-material .ag-rtl .ag-fill-handle {
  left: -1px;
}

.ag-theme-material .ag-fill-handle {
  cursor: cell;
}
.ag-theme-material .ag-range-handle {
  cursor: nwse-resize;
}
.ag-theme-material .ag-cell-inline-editing {
  border-color: #3f51b5 !important;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5)) !important;
}
.ag-theme-material .ag-menu {
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 2px;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
  padding: 0;
}
.ag-theme-material .ag-menu-list {
  cursor: default;
  padding: 8px 0;
}
.ag-theme-material .ag-menu-separator {
  height: 17px;
}
.ag-theme-material .ag-menu-separator-part::after {
  content: "";
  display: block;
  border-top: solid 1px;
  border-top-color: #e2e2e2;
  border-top-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-menu-option-active, .ag-theme-material .ag-compact-menu-option-active {
  background-color: #fafafa;
  background-color: var(--ag-row-hover-color, #fafafa);
}
.ag-theme-material .ag-menu-option-part, .ag-theme-material .ag-compact-menu-option-part {
  line-height: 18px;
  padding: 10px 0;
}
.ag-theme-material .ag-menu-option-disabled, .ag-theme-material .ag-compact-menu-option-disabled {
  opacity: 0.5;
}
.ag-theme-material .ag-menu-option-icon, .ag-theme-material .ag-compact-menu-option-icon {
  width: 18px;
}
.ag-theme-material .ag-ltr .ag-menu-option-icon, .ag-theme-material .ag-ltr .ag-compact-menu-option-icon {
  padding-left: 16px;
}

.ag-theme-material .ag-rtl .ag-menu-option-icon, .ag-theme-material .ag-rtl .ag-compact-menu-option-icon {
  padding-right: 16px;
}

.ag-theme-material .ag-menu-option-text, .ag-theme-material .ag-compact-menu-option-text {
  padding-left: 16px;
  padding-right: 16px;
}
.ag-theme-material .ag-ltr .ag-menu-option-shortcut, .ag-theme-material .ag-ltr .ag-compact-menu-option-shortcut {
  padding-right: 8px;
}

.ag-theme-material .ag-rtl .ag-menu-option-shortcut, .ag-theme-material .ag-rtl .ag-compact-menu-option-shortcut {
  padding-left: 8px;
}

.ag-theme-material .ag-menu-option-popup-pointer, .ag-theme-material .ag-compact-menu-option-popup-pointer {
  padding-right: 8px;
}
.ag-theme-material .ag-tabs {
  min-width: 220px;
}
.ag-theme-material .ag-tabs-header {
  width: 100%;
  display: -webkit-box;
  display: flex;
}
.ag-theme-material .ag-tab {
  border-bottom: 2px solid transparent;
  display: -webkit-box;
  display: flex;
  -webkit-box-flex: 0;
          flex: none;
  -webkit-box-align: center;
          align-items: center;
  -webkit-box-pack: center;
          justify-content: center;
  cursor: pointer;
  -webkit-box-flex: 1;
          flex: 1 1 auto;
}
.ag-theme-material .ag-keyboard-focus .ag-tab:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-tab:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-tab-selected {
  border-bottom-color: #3f51b5;
  border-bottom-color: var(--ag-selected-tab-underline-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-menu-header {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-filter-separator {
  border-top: solid 1px;
  border-top-color: #e2e2e2;
  border-top-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-menu:not(.ag-tabs) .ag-filter-select {
  min-width: 155px;
}
.ag-theme-material .ag-tabs .ag-filter-select {
  min-width: 194px;
}
.ag-theme-material .ag-filter-select .ag-picker-field-wrapper {
  width: 0;
}
.ag-theme-material .ag-filter-condition-operator {
  height: 17px;
}
.ag-theme-material .ag-ltr .ag-filter-condition-operator-or {
  margin-left: 16px;
}

.ag-theme-material .ag-rtl .ag-filter-condition-operator-or {
  margin-right: 16px;
}

.ag-theme-material .ag-set-filter-select-all {
  padding-top: 16px;
}
.ag-theme-material .ag-set-filter-list, .ag-theme-material .ag-filter-no-matches {
  height: 192px;
}
.ag-theme-material .ag-set-filter-filter {
  margin-top: 16px;
  margin-left: 12px;
  margin-right: 12px;
}
.ag-theme-material .ag-filter-to {
  margin-top: 14px;
}
.ag-theme-material .ag-mini-filter {
  margin: 16px 12px;
}
.ag-theme-material .ag-set-filter-item {
  margin: 0px 12px;
}
.ag-theme-material .ag-ltr .ag-set-filter-item-value {
  margin-left: 12px;
}

.ag-theme-material .ag-rtl .ag-set-filter-item-value {
  margin-right: 12px;
}

.ag-theme-material .ag-filter-apply-panel {
  padding: 16px 12px;
}
.ag-theme-material .ag-filter-apply-panel-button {
  line-height: 1.5;
}
.ag-theme-material .ag-ltr .ag-filter-apply-panel-button {
  margin-left: 16px;
}

.ag-theme-material .ag-rtl .ag-filter-apply-panel-button {
  margin-right: 16px;
}

.ag-theme-material .ag-simple-filter-body-wrapper {
  padding: 16px 12px;
  padding-bottom: 2px;
}
.ag-theme-material .ag-simple-filter-body-wrapper > * {
  margin-bottom: 14px;
}
.ag-theme-material .ag-filter-no-matches {
  padding: 16px 12px;
}
.ag-theme-material .ag-multi-filter-menu-item {
  margin: 8px 0;
}
.ag-theme-material .ag-multi-filter-group-title-bar {
  padding: 16px 8px;
  background-color: transparent;
}
.ag-theme-material .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-side-bar {
  position: relative;
}
.ag-theme-material .ag-tool-panel-wrapper {
  width: 200px;
  background-color: #fafafa;
  background-color: var(--ag-control-panel-background-color, #fafafa);
}
.ag-theme-material .ag-side-buttons {
  padding-top: 32px;
  width: 22px;
  position: relative;
  color: rgba(0, 0, 0, 0.87);
  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));
  overflow: hidden;
}
.ag-theme-material button.ag-side-button-button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  background: transparent;
  padding: 16px 0 16px 0;
  width: 100%;
  margin: 0;
  min-height: 144px;
  background-position-y: center;
  background-position-x: center;
  background-repeat: no-repeat;
  border: none;
}
.ag-theme-material button.ag-side-button-button:focus {
  -webkit-box-shadow: none;
          box-shadow: none;
}
.ag-theme-material .ag-keyboard-focus .ag-side-button-button:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-side-button-button:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-side-button-icon-wrapper {
  margin-bottom: 3px;
}
.ag-theme-material .ag-ltr .ag-side-bar-left .ag-side-button-button,
.ag-theme-material .ag-rtl .ag-side-bar-right .ag-side-button-button {
  border-right: 2px solid transparent;
}
.ag-theme-material .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,
.ag-theme-material .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button {
  border-right-color: #3f51b5;
  border-right-color: var(--ag-selected-tab-underline-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-rtl .ag-side-bar-left .ag-side-button-button,
.ag-theme-material .ag-ltr .ag-side-bar-right .ag-side-button-button {
  border-left: 2px solid transparent;
}
.ag-theme-material .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,
.ag-theme-material .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button {
  border-left-color: #3f51b5;
  border-left-color: var(--ag-selected-tab-underline-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-filter-toolpanel-header {
  height: 48px;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-header, .ag-theme-material .ag-ltr .ag-filter-toolpanel-search {
  padding-left: 8px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-header, .ag-theme-material .ag-rtl .ag-filter-toolpanel-search {
  padding-right: 8px;
}

.ag-theme-material .ag-keyboard-focus .ag-filter-toolpanel-header:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-filter-toolpanel-header:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  font-family: "agGridMaterial";
  font-size: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\f114";
  position: absolute;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  padding-left: 8px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {
  padding-right: 8px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-0-header {
  height: 64px;
}
.ag-theme-material .ag-filter-toolpanel-group-item {
  margin-top: 4px;
  margin-bottom: 4px;
}
.ag-theme-material .ag-filter-toolpanel-search {
  height: 56px;
}
.ag-theme-material .ag-filter-toolpanel-search-input {
  -webkit-box-flex: 1;
          flex-grow: 1;
  height: 32px;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-search-input {
  margin-right: 8px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-search-input {
  margin-left: 8px;
}

.ag-theme-material .ag-ltr .ag-filter-toolpanel-expand, .ag-theme-material .ag-ltr .ag-filter-toolpanel-group-title-bar-icon {
  margin-right: 8px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-expand, .ag-theme-material .ag-rtl .ag-filter-toolpanel-group-title-bar-icon {
  margin-left: 8px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {
  padding-left: 24px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {
  padding-right: 24px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {
  padding-left: 40px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {
  padding-right: 40px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {
  padding-left: 56px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {
  padding-right: 56px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {
  padding-left: 72px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {
  padding-right: 72px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {
  padding-left: 88px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {
  padding-right: 88px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {
  padding-left: 104px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {
  padding-right: 104px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {
  padding-left: 120px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {
  padding-right: 120px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {
  padding-left: 136px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {
  padding-right: 136px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {
  padding-left: 152px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {
  padding-right: 152px;
}

.ag-theme-material .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar {
  background-color: transparent;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {
  padding-left: 168px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {
  padding-right: 168px;
}

.ag-theme-material .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header {
  padding-left: 8px;
}
.ag-theme-material .ag-filter-toolpanel-instance-filter {
  margin-top: 8px;
}
.ag-theme-material .ag-ltr .ag-filter-toolpanel-instance-header-icon {
  margin-left: 8px;
}

.ag-theme-material .ag-rtl .ag-filter-toolpanel-instance-header-icon {
  margin-right: 8px;
}

.ag-theme-material .ag-pivot-mode-panel {
  min-height: 56px;
  height: 56px;
  display: -webkit-box;
  display: flex;
}
.ag-theme-material .ag-pivot-mode-select {
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
          align-items: center;
}
.ag-theme-material .ag-ltr .ag-pivot-mode-select {
  margin-left: 12px;
}

.ag-theme-material .ag-rtl .ag-pivot-mode-select {
  margin-right: 12px;
}

.ag-theme-material .ag-keyboard-focus .ag-column-select-header:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-column-select-header:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-column-select-header {
  height: 56px;
  -webkit-box-align: center;
          align-items: center;
  padding: 0 12px;
}
.ag-theme-material .ag-column-group-icons,
.ag-theme-material .ag-column-select-header-icon {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-column-select-list .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #3f51b5;
  background-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-column-select-list .ag-item-highlight-top::after {
  top: 0;
}
.ag-theme-material .ag-column-select-list .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-theme-material .ag-header {
  background-color: #fff;
  background-color: var(--ag-header-background-color, #fff);
  border-bottom: solid 1px;
  border-bottom-color: #e2e2e2;
  border-bottom-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-header-row {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));
  height: 56px;
}
.ag-theme-material .ag-pinned-right-header {
  border-left: solid 1px;
  border-left-color: #e2e2e2;
  border-left-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-pinned-left-header {
  border-right: solid 1px;
  border-right-color: #e2e2e2;
  border-right-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {
  margin-left: 8px;
}

.ag-theme-material .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {
  margin-right: 8px;
}

.ag-theme-material .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {
  margin-right: 8px;
}

.ag-theme-material .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {
  margin-left: 8px;
}

.ag-theme-material .ag-header-cell,
.ag-theme-material .ag-header-group-cell {
  padding-left: 24px;
  padding-right: 24px;
}
.ag-theme-material .ag-header-cell.ag-header-cell-moving,
.ag-theme-material .ag-header-group-cell.ag-header-cell-moving {
  background-color: #f2f2f2;
  background-color: var(--ag-header-cell-moving-background-color, var(--ag-header-cell-hover-background-color, #f2f2f2));
}
.ag-theme-material .ag-keyboard-focus .ag-header-cell:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-header-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-keyboard-focus .ag-header-group-cell:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-header-group-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 4px;
  left: 4px;
  display: block;
  width: calc(100% - 8px);
  height: calc(100% - 8px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-header-icon {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-header-expand-icon {
  cursor: pointer;
}
.ag-theme-material .ag-ltr .ag-header-expand-icon {
  padding-left: 4px;
}

.ag-theme-material .ag-rtl .ag-header-expand-icon {
  padding-right: 4px;
}

.ag-theme-material .ag-header-row:not(:first-child) .ag-header-cell,
.ag-theme-material .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {
  border-top: solid 1px;
  border-top-color: #e2e2e2;
  border-top-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell:not(.ag-header-cell-moving):hover, .ag-theme-material .ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell.ag-column-resizing,
.ag-theme-material .ag-header-cell:not(.ag-column-resizing) + .ag-header-cell:not(.ag-header-cell-moving):hover,
.ag-theme-material .ag-header-cell:not(.ag-column-resizing) + .ag-header-cell.ag-column-resizing,
.ag-theme-material .ag-header-group-cell:first-of-type:not(.ag-header-cell-moving):hover,
.ag-theme-material .ag-header-group-cell:first-of-type.ag-column-resizing,
.ag-theme-material .ag-header-cell:first-of-type:not(.ag-header-cell-moving):hover,
.ag-theme-material .ag-header-cell:first-of-type.ag-column-resizing {
  background-color: #f2f2f2;
  background-color: var(--ag-header-cell-hover-background-color, #f2f2f2);
}
.ag-theme-material .ag-ltr .ag-header-select-all {
  margin-right: 24px;
}

.ag-theme-material .ag-rtl .ag-header-select-all {
  margin-left: 24px;
}

.ag-theme-material .ag-ltr .ag-floating-filter-button {
  margin-left: 24px;
}

.ag-theme-material .ag-rtl .ag-floating-filter-button {
  margin-right: 24px;
}

.ag-theme-material .ag-floating-filter-button-button {
  color: inherit;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background: transparent;
  border: none;
  height: 18px;
  padding: 0;
  width: 18px;
}
.ag-theme-material .ag-filter-loading {
  background-color: #fafafa;
  background-color: var(--ag-control-panel-background-color, #fafafa);
  height: 100%;
  padding: 16px 12px;
  position: absolute;
  width: 100%;
  z-index: 1;
}
.ag-theme-material .ag-paging-panel {
  border-top: 1px solid;
  border-top-color: #e2e2e2;
  border-top-color: var(--ag-border-color, #e2e2e2);
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
  height: 56px;
}
.ag-theme-material .ag-paging-panel > * {
  margin: 0 24px;
}
.ag-theme-material .ag-paging-button {
  cursor: pointer;
}
.ag-theme-material .ag-paging-button.ag-disabled {
  cursor: default;
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-material .ag-keyboard-focus .ag-paging-button:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-paging-button:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 0px;
  left: 0px;
  display: block;
  width: calc(100% - 0px);
  height: calc(100% - 0px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-paging-button, .ag-theme-material .ag-paging-description {
  margin: 0 8px;
}
.ag-theme-material .ag-status-bar {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  padding-right: 32px;
  padding-left: 32px;
  line-height: 1.5;
}
.ag-theme-material .ag-status-name-value-value {
  color: rgba(0, 0, 0, 0.87);
  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));
}
.ag-theme-material .ag-status-bar-center {
  text-align: center;
}
.ag-theme-material .ag-status-name-value {
  margin-left: 8px;
  margin-right: 8px;
  padding-top: 16px;
  padding-bottom: 16px;
}
.ag-theme-material .ag-column-drop-cell {
  background: #e2e2e2;
  background: var(--ag-chip-background-color, #e2e2e2);
  border-radius: 32px;
  height: 32px;
  padding: 0 4px;
  border: 1px solid transparent;
}
.ag-theme-material .ag-keyboard-focus .ag-column-drop-cell:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-column-drop-cell:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 2px;
  left: 2px;
  display: block;
  width: calc(100% - 4px);
  height: calc(100% - 4px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-column-drop-cell-text {
  margin: 0 8px;
}
.ag-theme-material .ag-column-drop-cell-button {
  min-width: 32px;
  margin: 0 4px;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-column-drop-cell-drag-handle {
  margin-left: 16px;
}
.ag-theme-material .ag-column-drop-cell-ghost {
  opacity: 0.5;
}
.ag-theme-material .ag-column-drop-horizontal {
  background-color: #fafafa;
  background-color: var(--ag-control-panel-background-color, #fafafa);
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
  height: 48px;
}
.ag-theme-material .ag-ltr .ag-column-drop-horizontal {
  padding-left: 24px;
}

.ag-theme-material .ag-rtl .ag-column-drop-horizontal {
  padding-right: 24px;
}

.ag-theme-material .ag-column-drop-horizontal-cell-separator {
  margin: 0 8px;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-column-drop-horizontal-empty-message {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-material .ag-ltr .ag-column-drop-horizontal-icon {
  margin-right: 24px;
}

.ag-theme-material .ag-rtl .ag-column-drop-horizontal-icon {
  margin-left: 24px;
}

.ag-theme-material .ag-column-drop-vertical-list {
  padding-bottom: 8px;
  padding-right: 8px;
  padding-left: 8px;
}
.ag-theme-material .ag-column-drop-vertical-cell {
  margin-top: 8px;
}
.ag-theme-material .ag-column-drop-vertical {
  min-height: 50px;
}
.ag-theme-material .ag-column-drop-vertical-icon {
  margin-left: 8px;
  margin-right: 8px;
}
.ag-theme-material .ag-column-drop-vertical-empty-message {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  margin-top: 8px;
}
.ag-theme-material .ag-select-agg-func-popup {
  background: #fff;
  background: var(--ag-background-color, #fff);
  border-radius: 2px;
  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  padding: 8px;
  background: #fff;
  background: var(--ag-background-color, #fff);
  height: 140px;
  padding: 0;
}
.ag-theme-material .ag-select-agg-func-virtual-list-item {
  cursor: default;
  padding-left: 16px;
}
.ag-theme-material .ag-select-agg-func-virtual-list-item:hover {
  background-color: #eee;
  background-color: var(--ag-selected-row-background-color, #eee);
}
.ag-theme-material .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus {
  outline: none;
}
.ag-theme-material .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus::after {
  content: "";
  position: absolute;
  background-color: transparent;
  pointer-events: none;
  top: 1px;
  left: 1px;
  display: block;
  width: calc(100% - 2px);
  height: calc(100% - 2px);
  border: 1px solid;
  border-color: #3f51b5;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-chart-menu {
  border-radius: 2px;
  background: #fff;
  background: var(--ag-background-color, #fff);
}
.ag-theme-material .ag-chart-menu-icon {
  opacity: 0.5;
  line-height: 24px;
  font-size: 24px;
  width: 24px;
  height: 24px;
  margin: 2px 0;
  cursor: pointer;
  border-radius: 2px;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-chart-menu-icon:hover {
  opacity: 1;
}
.ag-theme-material .ag-chart-mini-thumbnail {
  border: 1px solid;
  border-color: #e2e2e2;
  border-color: var(--ag-secondary-border-color, var(--ag-border-color, #e2e2e2));
  border-radius: 5px;
  margin: 5px;
}
.ag-theme-material .ag-chart-mini-thumbnail:nth-last-child(3), .ag-theme-material .ag-chart-mini-thumbnail:nth-last-child(3) ~ .ag-chart-mini-thumbnail {
  margin-left: auto;
  margin-right: auto;
}
.ag-theme-material .ag-ltr .ag-chart-mini-thumbnail:first-child {
  margin-left: 0;
}

.ag-theme-material .ag-rtl .ag-chart-mini-thumbnail:first-child {
  margin-right: 0;
}

.ag-theme-material .ag-ltr .ag-chart-mini-thumbnail:last-child {
  margin-right: 0;
}

.ag-theme-material .ag-rtl .ag-chart-mini-thumbnail:last-child {
  margin-left: 0;
}

.ag-theme-material .ag-chart-mini-thumbnail.ag-selected {
  border-color: #ff4081;
  border-color: var(--ag-minichart-selected-chart-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));
}
.ag-theme-material .ag-chart-settings-card-item {
  background: rgba(0, 0, 0, 0.87);
  background: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));
  width: 8px;
  height: 8px;
  border-radius: 4px;
}
.ag-theme-material .ag-chart-settings-card-item.ag-selected {
  background-color: #ff4081;
  background-color: var(--ag-minichart-selected-page-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));
}
.ag-theme-material .ag-chart-data-column-drag-handle {
  margin-left: 8px;
}
.ag-theme-material .ag-charts-settings-group-container {
  padding: 8px;
}
.ag-theme-material .ag-charts-data-group-container {
  padding: 8px 12px;
}
.ag-theme-material .ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group) {
  height: 32px;
}
.ag-theme-material .ag-charts-data-group-container .ag-list-item-hovered::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  background-color: #3f51b5;
  background-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material .ag-charts-data-group-container .ag-item-highlight-top::after {
  top: 0;
}
.ag-theme-material .ag-charts-data-group-container .ag-item-highlight-bottom::after {
  bottom: 0;
}
.ag-theme-material .ag-charts-format-top-level-group-container {
  margin-left: 16px;
  padding: 8px;
}
.ag-theme-material .ag-charts-format-top-level-group-item {
  margin: 8px 0;
}
.ag-theme-material .ag-charts-format-sub-level-group-container {
  padding: 16px 12px;
  padding-bottom: 2px;
}
.ag-theme-material .ag-charts-format-sub-level-group-container > * {
  margin-bottom: 14px;
}
.ag-theme-material .ag-charts-group-container.ag-group-container-horizontal {
  padding: 8px;
}
.ag-theme-material .ag-chart-data-section,
.ag-theme-material .ag-chart-format-section {
  display: -webkit-box;
  display: flex;
  margin: 0;
}
.ag-theme-material .ag-chart-menu-panel {
  background-color: #fafafa;
  background-color: var(--ag-control-panel-background-color, #fafafa);
}
.ag-theme-material .ag-ltr .ag-chart-menu-panel {
  border-left: solid 1px;
  border-left-color: #e2e2e2;
  border-left-color: var(--ag-border-color, #e2e2e2);
}

.ag-theme-material .ag-rtl .ag-chart-menu-panel {
  border-right: solid 1px;
  border-right-color: #e2e2e2;
  border-right-color: var(--ag-border-color, #e2e2e2);
}

.ag-theme-material .ag-date-time-list-page-title {
  -webkit-box-flex: 1;
          flex-grow: 1;
  text-align: center;
}
.ag-theme-material .ag-date-time-list-page-column-label {
  text-align: center;
}
.ag-theme-material .ag-date-time-list-page-entry {
  text-align: center;
}
.ag-theme-material .ag-checkbox-input-wrapper {
  font-family: "agGridMaterial";
  font-size: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 18px;
  height: 18px;
  background-color: var(--ag-checkbox-background-color);
  border-radius: 2px;
  display: inline-block;
  vertical-align: middle;
  -webkit-box-flex: 0;
          flex: none;
}
.ag-theme-material .ag-checkbox-input-wrapper input, .ag-theme-material .ag-checkbox-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-theme-material .ag-checkbox-input-wrapper:focus-within, .ag-theme-material .ag-checkbox-input-wrapper:active {
  outline: none;
  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
}
.ag-theme-material .ag-checkbox-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-material .ag-checkbox-input-wrapper::after {
  content: "\\f108";
  color: #333;
  color: var(--ag-checkbox-unchecked-color, #333);
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {
  content: "\\f106";
  color: #ff4081;
  color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-material .ag-checkbox-input-wrapper.ag-indeterminate::after {
  content: "\\f107";
  color: #333;
  color: var(--ag-checkbox-indeterminate-color, var(--ag-checkbox-unchecked-color, #333));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-material .ag-toggle-button-input-wrapper {
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  width: 36px;
  height: 18px;
  background-color: #333;
  background-color: var(--ag-toggle-button-off-background-color, var(--ag-checkbox-unchecked-color, #333));
  border-radius: 9px;
  position: relative;
  -webkit-box-flex: 0;
          flex: none;
  border: 1px solid;
  border-color: #333;
  border-color: var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #333));
}
.ag-theme-material .ag-toggle-button-input-wrapper input {
  opacity: 0;
  height: 100%;
  width: 100%;
}
.ag-theme-material .ag-toggle-button-input-wrapper:focus-within {
  outline: none;
  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
}
.ag-theme-material .ag-toggle-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-material .ag-toggle-button-input-wrapper.ag-checked {
  background-color: #ff4081;
  background-color: var(--ag-toggle-button-on-background-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));
  border-color: #ff4081;
  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));
}
.ag-theme-material .ag-toggle-button-input-wrapper::before {
  content: " ";
  position: absolute;
  top: -1px;
  left: -1px;
  display: block;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  height: 18px;
  width: 18px;
  background-color: #fff;
  background-color: var(--ag-toggle-button-switch-background-color, var(--ag-background-color, #fff));
  border-radius: 9px;
  -webkit-transition: left 100ms;
  transition: left 100ms;
  border: 1px solid;
  border-color: #333;
  border-color: var(--ag-toggle-button-switch-border-color, var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #333)));
}
.ag-theme-material .ag-toggle-button-input-wrapper.ag-checked::before {
  left: calc(100% - 18px );
  border-color: #ff4081;
  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));
}
.ag-theme-material .ag-radio-button-input-wrapper {
  font-family: "agGridMaterial";
  font-size: 18px;
  line-height: 18px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 18px;
  height: 18px;
  background-color: var(--ag-checkbox-background-color);
  border-radius: 2px;
  display: inline-block;
  vertical-align: middle;
  -webkit-box-flex: 0;
          flex: none;
  border-radius: 18px;
}
.ag-theme-material .ag-radio-button-input-wrapper input, .ag-theme-material .ag-radio-button-input-wrapper input {
  -webkit-appearance: none;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ag-theme-material .ag-radio-button-input-wrapper:focus-within, .ag-theme-material .ag-radio-button-input-wrapper:active {
  outline: none;
  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
}
.ag-theme-material .ag-radio-button-input-wrapper.ag-disabled {
  opacity: 0.5;
}
.ag-theme-material .ag-radio-button-input-wrapper::after {
  content: "\\f126";
  color: #333;
  color: var(--ag-checkbox-unchecked-color, #333);
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-material .ag-radio-button-input-wrapper.ag-checked::after {
  content: "\\f127";
  color: #ff4081;
  color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
.ag-theme-material input[class^=ag-][type=range] {
  -webkit-appearance: none;
  width: 100%;
  height: 100%;
  background: none;
  overflow: visible;
}
.ag-theme-material input[class^=ag-][type=range]::-webkit-slider-runnable-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #e2e2e2;
  background-color: var(--ag-border-color, #e2e2e2);
  border-radius: 0px;
  border-radius: 2px;
}
.ag-theme-material input[class^=ag-][type=range]::-moz-range-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #e2e2e2;
  background-color: var(--ag-border-color, #e2e2e2);
  border-radius: 0px;
  border-radius: 2px;
}
.ag-theme-material input[class^=ag-][type=range]::-ms-track {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 3px;
  background-color: #e2e2e2;
  background-color: var(--ag-border-color, #e2e2e2);
  border-radius: 0px;
  border-radius: 2px;
  color: transparent;
  width: calc(100% - 2px);
}
.ag-theme-material input[class^=ag-][type=range]::-webkit-slider-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  border: 1px solid;
  border-color: #333;
  border-color: var(--ag-checkbox-unchecked-color, #333);
  border-radius: 18px;
  -webkit-transform: translateY(-7.5px);
          transform: translateY(-7.5px);
}
.ag-theme-material input[class^=ag-][type=range]::-ms-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  border: 1px solid;
  border-color: #333;
  border-color: var(--ag-checkbox-unchecked-color, #333);
  border-radius: 18px;
}
.ag-theme-material input[class^=ag-][type=range]::-moz-ag-range-thumb {
  margin: 0;
  padding: 0;
  -webkit-appearance: none;
  width: 18px;
  height: 18px;
  background-color: #fff;
  background-color: var(--ag-background-color, #fff);
  border: 1px solid;
  border-color: #333;
  border-color: var(--ag-checkbox-unchecked-color, #333);
  border-radius: 18px;
}
.ag-theme-material input[class^=ag-][type=range]:focus {
  outline: none;
}
.ag-theme-material input[class^=ag-][type=range]:focus::-webkit-slider-thumb {
  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
  border-color: #ff4081;
  border-color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));
}
.ag-theme-material input[class^=ag-][type=range]:focus::-ms-thumb {
  box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
  border-color: #ff4081;
  border-color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));
}
.ag-theme-material input[class^=ag-][type=range]:focus::-moz-ag-range-thumb {
  box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);
  border-color: #ff4081;
  border-color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));
}
.ag-theme-material input[class^=ag-][type=range]:active::-webkit-slider-runnable-track {
  background-color: #3f51b5;
  background-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material input[class^=ag-][type=range]:active::-moz-ag-range-track {
  background-color: #3f51b5;
  background-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material input[class^=ag-][type=range]:active::-ms-track {
  background-color: #3f51b5;
  background-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));
}
.ag-theme-material input[class^=ag-][type=range]:disabled {
  opacity: 0.5;
}
.ag-theme-material .ag-filter-toolpanel-header,
.ag-theme-material .ag-filter-toolpanel-search,
.ag-theme-material .ag-status-bar,
.ag-theme-material .ag-header-row,
.ag-theme-material .ag-panel-title-bar-title,
.ag-theme-material .ag-side-button-button,
.ag-theme-material .ag-multi-filter-group-title-bar {
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));
}
.ag-theme-material .ag-tab {
  height: 36px;
}
.ag-theme-material .ag-tabs-header,
.ag-theme-material .ag-column-drop-horizontal {
  background-color: #eee;
  background-color: var(--ag-subheader-background-color, #eee);
}
.ag-theme-material .ag-tabs-body {
  padding: 4px 0;
}
.ag-theme-material .ag-tabs-body .ag-menu-list {
  padding-top: 0;
  padding-bottom: 0;
}
.ag-theme-material .ag-header-cell, .ag-theme-material .ag-header-group-cell {
  -webkit-transition: background-color 0.5s;
  transition: background-color 0.5s;
}
.ag-theme-material .ag-row-last:not(.ag-row-first) .ag-cell-inline-editing {
  bottom: 0;
}
.ag-theme-material .ag-cell-inline-editing {
  padding: 8px;
  height: 72px;
  border-color: #e2e2e2 !important;
  border-color: var(--ag-border-color, #e2e2e2) !important;
}
.ag-theme-material .ag-has-focus .ag-cell-inline-editing {
  border-color: #3f51b5 !important;
  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5)) !important;
}
.ag-theme-material .ag-side-button-button {
  color: rgba(0, 0, 0, 0.54);
  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));
}
.ag-theme-material .ag-column-drop-vertical {
  border-bottom: solid 1px;
  border-bottom-color: #e2e2e2;
  border-bottom-color: var(--ag-border-color, #e2e2e2);
  padding-top: 8px;
}
.ag-theme-material .ag-column-drop-vertical.ag-last-column-drop {
  border-bottom: none;
}
.ag-theme-material .ag-column-drop-vertical-cell {
  margin-left: 0;
}
.ag-theme-material .ag-column-drop-vertical-empty-message {
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-material .ag-ltr .ag-column-drop-vertical-empty-message {
  padding-left: 34px;
  padding-right: 8px;
}

.ag-theme-material .ag-rtl .ag-column-drop-vertical-empty-message {
  padding-right: 34px;
  padding-left: 8px;
}

.ag-theme-material .ag-status-bar {
  border: solid 1px;
  border-color: #e2e2e2;
  border-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-column-panel-column-select {
  border-top: solid 1px;
  border-top-color: #e2e2e2;
  border-top-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-column-select, .ag-theme-material .ag-column-select-header {
  border-bottom: solid 1px;
  border-bottom-color: #e2e2e2;
  border-bottom-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material .ag-column-select-header {
  height: 56px;
}
.ag-theme-material .ag-group-title-bar {
  padding: 6px 8px;
}
.ag-theme-material .ag-charts-format-sub-level-group-title-bar {
  padding: 4px 8px;
}
.ag-theme-material .ag-chart-data-section,
.ag-theme-material .ag-chart-format-section {
  padding-bottom: 4px;
}
.ag-theme-material .ag-group-toolbar {
  background-color: rgba(238, 238, 238, 0.5);
}
.ag-theme-material input[class^=ag-]:not([type]),
.ag-theme-material input[class^=ag-][type=text],
.ag-theme-material input[class^=ag-][type=number],
.ag-theme-material input[class^=ag-][type=tel],
.ag-theme-material input[class^=ag-][type=date],
.ag-theme-material input[class^=ag-][type=datetime-local],
.ag-theme-material textarea[class^=ag-] {
  background: transparent;
  color: rgba(0, 0, 0, 0.87);
  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));
  font-family: inherit;
  font-size: inherit;
  height: 40px;
  padding-bottom: 8px;
  border-width: 0;
  border-bottom: 2px solid;
  border-bottom-color: #e2e2e2;
  border-bottom-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material input[class^=ag-]:focus:not([type]),
.ag-theme-material input[class^=ag-][type=text]:focus,
.ag-theme-material input[class^=ag-][type=number]:focus,
.ag-theme-material input[class^=ag-][type=tel]:focus,
.ag-theme-material input[class^=ag-][type=date]:focus,
.ag-theme-material input[class^=ag-][type=datetime-local]:focus,
.ag-theme-material textarea[class^=ag-]:focus {
  border-bottom: 2px solid;
  border-bottom-color: #3f51b5;
  border-bottom-color: var(--ag-material-primary-color, #3f51b5);
  outline: none;
  -webkit-box-shadow: none;
          box-shadow: none;
}
.ag-theme-material input[class^=ag-]:not([type])::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=text]::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=number]::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=tel]::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=date]::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=datetime-local]::-webkit-input-placeholder, .ag-theme-material textarea[class^=ag-]::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-material input[class^=ag-]:not([type])::-moz-placeholder, .ag-theme-material input[class^=ag-][type=text]::-moz-placeholder, .ag-theme-material input[class^=ag-][type=number]::-moz-placeholder, .ag-theme-material input[class^=ag-][type=tel]::-moz-placeholder, .ag-theme-material input[class^=ag-][type=date]::-moz-placeholder, .ag-theme-material input[class^=ag-][type=datetime-local]::-moz-placeholder, .ag-theme-material textarea[class^=ag-]::-moz-placeholder {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-material input[class^=ag-]:not([type])::placeholder,
.ag-theme-material input[class^=ag-][type=text]::placeholder,
.ag-theme-material input[class^=ag-][type=number]::placeholder,
.ag-theme-material input[class^=ag-][type=tel]::placeholder,
.ag-theme-material input[class^=ag-][type=date]::placeholder,
.ag-theme-material input[class^=ag-][type=datetime-local]::placeholder,
.ag-theme-material textarea[class^=ag-]::placeholder {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
}
.ag-theme-material input[class^=ag-]:disabled:not([type]),
.ag-theme-material input[class^=ag-][type=text]:disabled,
.ag-theme-material input[class^=ag-][type=number]:disabled,
.ag-theme-material input[class^=ag-][type=tel]:disabled,
.ag-theme-material input[class^=ag-][type=date]:disabled,
.ag-theme-material input[class^=ag-][type=datetime-local]:disabled,
.ag-theme-material textarea[class^=ag-]:disabled {
  border-bottom: 1px solid;
  border-bottom-color: #e2e2e2;
  border-bottom-color: var(--ag-border-color, #e2e2e2);
}
.ag-theme-material input[class^=ag-]:invalid:not([type]),
.ag-theme-material input[class^=ag-][type=text]:invalid,
.ag-theme-material input[class^=ag-][type=number]:invalid,
.ag-theme-material input[class^=ag-][type=tel]:invalid,
.ag-theme-material input[class^=ag-][type=date]:invalid,
.ag-theme-material input[class^=ag-][type=datetime-local]:invalid,
.ag-theme-material textarea[class^=ag-]:invalid {
  border-width: 0;
  border-bottom: 1px solid;
  border-bottom-color: #e02525;
  border-bottom-color: var(--ag-invalid-color, #e02525);
  color: #e02525;
  color: var(--ag-invalid-color, #e02525);
}
.ag-theme-material .ag-standard-button {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: transparent;
  border: 0;
  color: #3f51b5;
  color: var(--ag-material-primary-color, #3f51b5);
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
}
.ag-theme-material .ag-standard-button:disabled {
  color: rgba(0, 0, 0, 0.38);
  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));
  background-color: var(--ag-input-disabled-background-color);
  border-color: var(--ag-input-disabled-border-color);
}
.ag-theme-material .ag-dnd-ghost {
  font-size: 12px;
  font-weight: 600;
}
.ag-theme-material .ag-filter-toolpanel-header {
  height: 32px;
}
.ag-theme-material .ag-filter-toolpanel-group-level-0-header {
  height: 56px;
}
.ag-theme-material .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-material .ag-layout-auto-height .ag-center-cols-container, .ag-theme-material .ag-layout-print .ag-center-cols-clipper, .ag-theme-material .ag-layout-print .ag-center-cols-container {
  min-height: 150px;
}
.ag-theme-material .ag-overlay-no-rows-wrapper.ag-layout-auto-height {
  padding-top: 60px;
}
.ag-theme-material .ag-picker-field-wrapper:focus {
  -webkit-box-shadow: 0 0 0 1px #3f51b5;
          box-shadow: 0 0 0 1px #3f51b5;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ag-grid-community/dist/styles/ag-theme-material.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,sDAAsD;EACtD,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,2DAAmuN;EACnuN,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;;EAEE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;UACX,UAAU;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kDAAkD;AACpD;AACA;;EAEE,sBAAsB;EACtB,kDAAkD;AACpD;AACA;;;;;;;EAOE,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;;;;;;;EAOE,0BAA0B;EAC1B,+DAA+D;EAC/D,2DAA2D;EAC3D,mDAAmD;AACrD;AACA;;;;;;;EAOE,aAAa;EACb,qDAAqD;UAC7C,6CAA6C;EACrD,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;;;;;;;EAOE,iBAAiB;EACjB,mBAAmB;EACnB,kDAAkD;AACpD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;EACxB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,qDAAqD;UAC7C,6CAA6C;AACvD;AACA;EACE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,qBAAqB;EACrB,YAAY;AACd;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAA+D;AACjE;AACA;;;;EAIE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;EAC3B,mBAAmB;UACX,UAAU;AACpB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,eAAe;EACf,mBAAmB;UACX,UAAU;EAClB,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,4DAA4D;EAC5D,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,2EAA2E;AAC7E;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;EAC7C,kBAAkB;AACpB;AACA;EACE,qDAAqD;UAC7C,6CAA6C;AACvD;AACA;EACE,sBAAsB;EACtB,kDAAkD;EAClD,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,wGAAwG;EACxG,0EAA0E;AAC5E;AACA;EACE,0GAA0G;EAC1G,wEAAwE;AAC1E;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,mDAAmD;UAC3C,2CAA2C;AACrD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,mDAAmD;UAC3C,2CAA2C;AACrD;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,uHAAuH;UAC/G,+GAA+G;EACvH,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gEAAgE;EAChE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,mCAAmC;UAC3B,2BAA2B;AACrC;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,sDAAsD;AACxD;AACA;EACE,mDAAmD;UAC3C,2CAA2C;AACrD;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,sBAAsB;EACtB,yDAAyD;EACzD,0BAA0B;EAC1B,mGAAmG;EACnG,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;EACzD,0BAA0B;EAC1B,sDAAsD;EACtD,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,0BAA0B;EAC1B,+DAA+D;EAC/D,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,qDAAqD;AACvD;AACA;EACE,cAAc;EACd,uDAAuD;AACzD;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,kFAAkF;EAClF,yCAAyC;EACzC,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,6FAA6F;AAC/F;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,oCAAoC;EACpC,+EAA+E;AACjF;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,0BAA0B;EAC1B,4EAA4E;EAC5E,iBAAiB;EACjB,qBAAqB;EACrB,2GAA2G;EAC3G,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,mGAAmG;EACnG,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,MAAM;AACR;AACA;EACE,WAAW;AACb;AACA;EACE,oDAAoD;AACtD;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,yBAAyB;EACzB,uDAAuD;AACzD;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,mDAAmD;EACnD,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,uHAAuH;UAC/G,+GAA+G;EACvH,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,uHAAuH;UAC/G,+GAA+G;EACvH,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;EACnE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kDAAkD;AACpD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,qFAAqF;AACvF;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,uHAAuH;UAC/G,+GAA+G;EACvH,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,YAAY;EACZ,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4BAA4B;UACpB,oBAAoB;EAC5B,kCAAkC;UAC1B,0BAA0B;EAClC,2CAA2C;UACnC,mCAAmC;EAC3C,yCAAyC;UACjC,iCAAiC;AAC3C;AACA;EACE;IACE,+BAA+B;YACvB,uBAAuB;EACjC;EACA;IACE,iCAAiC;YACzB,yBAAyB;EACnC;AACF;AACA;EACE;IACE,+BAA+B;YACvB,uBAAuB;EACjC;EACA;IACE,iCAAiC;YACzB,yBAAyB;EACnC;AACF;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,sBAAsB;EACtB,+DAA+D;AACjE;AACA;;EAEE,0CAA0C;EAC1C,sFAAsF;AACxF;AACA;;EAEE,kDAAkD;EAClD,oGAAoG;AACtG;AACA;;EAEE,mDAAmD;EACnD,8GAA8G;AAChH;AACA;;EAEE,0CAA0C;EAC1C,oIAAoI;AACtI;AACA;;EAEE,2CAA2C;EAC3C,yFAAyF;AAC3F;AACA;;EAEE,4CAA4C;EAC5C,0FAA0F;AAC5F;AACA;;EAEE,6CAA6C;EAC7C,2FAA2F;AAC7F;AACA;EACE,yBAAyB;EACzB,mGAAmG;AACrG;AACA;EACE,2BAA2B;EAC3B,qGAAqG;AACvG;AACA;EACE,4BAA4B;EAC5B,sGAAsG;AACxG;AACA;EACE,0BAA0B;EAC1B,oGAAoG;AACtG;AACA;;;;;;;;;EASE,iBAAiB;EACjB,qBAAqB;EACrB,+FAA+F;EAC/F,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,mGAAmG;AACrG;AACA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,qGAAqG;AACvG;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,oGAAoG;AACtG;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;EAC5B,sGAAsG;AACxG;AACA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,oGAAoG;AACtG;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,qGAAqG;AACvG;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mGAAmG;AACrG;AACA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,sGAAsG;AACxG;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,uHAAuH;UAC/G,+GAA+G;EACvH,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;UACX,UAAU;EAClB,yBAAyB;UACjB,mBAAmB;EAC3B,wBAAwB;UAChB,uBAAuB;EAC/B,eAAe;EACf,mBAAmB;UACX,cAAc;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,4BAA4B;EAC5B,sGAAsG;AACxG;AACA;EACE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,QAAQ;AACV;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,mCAAmC;AACrC;AACA;;EAEE,2BAA2B;EAC3B,qGAAqG;AACvG;AACA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,0BAA0B;EAC1B,oGAAoG;AACtG;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;UACX,YAAY;EACpB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;UACjB,mBAAmB;AAC7B;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,YAAY;EACZ,yBAAyB;UACjB,mBAAmB;EAC3B,eAAe;AACjB;AACA;;EAEE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,mGAAmG;AACrG;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,yDAAyD;EACzD,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,0BAA0B;EAC1B,mGAAmG;EACnG,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;EACzB,sHAAsH;AACxH;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;;;;;;;EAOE,yBAAyB;EACzB,uEAAuE;AACzE;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;EACjD,0BAA0B;EAC1B,gEAAgE;EAChE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,+DAA+D;EAC/D,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,sDAAsD;AACxD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;EACb,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,0BAA0B;EAC1B,gEAAgE;EAChE,YAAY;AACd;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,0BAA0B;EAC1B,+DAA+D;EAC/D,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,uHAAuH;UAC/G,+GAA+G;EACvH,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,aAAa;EACb,UAAU;AACZ;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,+DAA+D;AACjE;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,2FAA2F;AAC7F;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,+EAA+E;EAC/E,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kIAAkI;AACpI;AACA;EACE,+BAA+B;EAC/B,2DAA2D;EAC3D,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,qIAAqI;AACvI;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,mGAAmG;AACrG;AACA;EACE,MAAM;AACR;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;AACA;;EAEE,oBAAoB;EACpB,aAAa;EACb,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;UACX,YAAY;EACpB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;UACX,UAAU;AACpB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,qDAAqD;UAC7C,6CAA6C;AACvD;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iFAAiF;EACjF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,uFAAuF;EACvF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,8BAA8B;UACtB,sBAAsB;EAC9B,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,wGAAwG;EACxG,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;UACX,UAAU;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gGAAgG;AAClG;AACA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,aAAa;EACb,qDAAqD;UAC7C,6CAA6C;AACvD;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,yIAAyI;EACzI,qBAAqB;EACrB,iIAAiI;AACnI;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,cAAc;EACd,8BAA8B;UACtB,sBAAsB;EAC9B,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,mGAAmG;EACnG,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,6IAA6I;AAC/I;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,iIAAiI;AACnI;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;UACX,UAAU;EAClB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,qDAAqD;UAC7C,6CAA6C;AACvD;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,+CAA+C;EAC/C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iFAAiF;EACjF,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,iBAAiB;EACjB,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;EACnB,qCAAqC;UAC7B,6BAA6B;AACvC;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,iBAAiB;EACjB,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;EAClD,iBAAiB;EACjB,kBAAkB;EAClB,sDAAsD;EACtD,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,qDAAqD;UAC7C,6CAA6C;EACrD,qBAAqB;EACrB,wFAAwF;AAC1F;AACA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,wFAAwF;AAC1F;AACA;EACE,6CAA6C;EAC7C,qBAAqB;EACrB,wFAAwF;AAC1F;AACA;EACE,yBAAyB;EACzB,+FAA+F;AACjG;AACA;EACE,yBAAyB;EACzB,+FAA+F;AACjG;AACA;EACE,yBAAyB;EACzB,+FAA+F;AACjG;AACA;EACE,YAAY;AACd;AACA;;;;;;;EAOE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mGAAmG;AACrG;AACA;EACE,YAAY;AACd;AACA;;EAEE,sBAAsB;EACtB,4DAA4D;AAC9D;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,iCAAiC;AACnC;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,wDAAwD;AAC1D;AACA;EACE,gCAAgC;EAChC,sGAAsG;AACxG;AACA;EACE,0BAA0B;EAC1B,gEAAgE;AAClE;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;EACpD,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,6CAA6C;AAC/C;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,0CAA0C;AAC5C;AACA;;;;;;;EAOE,uBAAuB;EACvB,0BAA0B;EAC1B,sDAAsD;EACtD,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;;;;;;;EAOE,wBAAwB;EACxB,4BAA4B;EAC5B,8DAA8D;EAC9D,aAAa;EACb,wBAAwB;UAChB,gBAAgB;AAC1B;AACA;EACE,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;EACE,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;;;;;;;EAOE,0BAA0B;EAC1B,+DAA+D;AACjE;AACA;;;;;;;EAOE,wBAAwB;EACxB,4BAA4B;EAC5B,oDAAoD;AACtD;AACA;;;;;;;EAOE,eAAe;EACf,wBAAwB;EACxB,4BAA4B;EAC5B,qDAAqD;EACrD,cAAc;EACd,uCAAuC;AACzC;AACA;EACE,wBAAwB;KACrB,qBAAqB;UAChB,gBAAgB;EACxB,6BAA6B;EAC7B,SAAS;EACT,cAAc;EACd,gDAAgD;EAChD,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,+DAA+D;EAC/D,2DAA2D;EAC3D,mDAAmD;AACrD;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qCAAqC;UAC7B,6BAA6B;AACvC","sourcesContent":[".ag-theme-material {\n  -webkit-font-smoothing: antialiased;\n  color: rgba(0, 0, 0, 0.87);\n  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));\n  font-family: \"Roboto\", sans-serif;\n  font-size: 13px;\n  line-height: normal;\n}\n@font-face {\n  font-family: \"agGridMaterial\";\n  src: url(\"data:application/font-woff;charset=utf-8;base64,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\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.ag-theme-material .ag-icon {\n  font-family: \"agGridMaterial\";\n  font-size: 18px;\n  line-height: 18px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.ag-theme-material .ag-icon-aggregation::before {\n  content: \"\\f101\";\n}\n.ag-theme-material .ag-icon-arrows::before {\n  content: \"\\f102\";\n}\n.ag-theme-material .ag-icon-asc::before {\n  content: \"\\f103\";\n}\n.ag-theme-material .ag-icon-cancel::before {\n  content: \"\\f104\";\n}\n.ag-theme-material .ag-icon-chart::before {\n  content: \"\\f105\";\n}\n.ag-theme-material .ag-icon-color-picker::before {\n  content: \"\\f109\";\n}\n.ag-theme-material .ag-icon-columns::before {\n  content: \"\\f10a\";\n}\n.ag-theme-material .ag-icon-contracted::before {\n  content: \"\\f10b\";\n}\n.ag-theme-material .ag-icon-copy::before {\n  content: \"\\f10c\";\n}\n.ag-theme-material .ag-icon-cross::before {\n  content: \"\\f10d\";\n}\n.ag-theme-material .ag-icon-csv::before {\n  content: \"\\f10e\";\n}\n.ag-theme-material .ag-icon-desc::before {\n  content: \"\\f10f\";\n}\n.ag-theme-material .ag-icon-excel::before {\n  content: \"\\f110\";\n}\n.ag-theme-material .ag-icon-expanded::before {\n  content: \"\\f111\";\n}\n.ag-theme-material .ag-icon-eye-slash::before {\n  content: \"\\f112\";\n}\n.ag-theme-material .ag-icon-eye::before {\n  content: \"\\f113\";\n}\n.ag-theme-material .ag-icon-filter::before {\n  content: \"\\f114\";\n}\n.ag-theme-material .ag-icon-first::before {\n  content: \"\\f115\";\n}\n.ag-theme-material .ag-icon-grip::before {\n  content: \"\\f116\";\n}\n.ag-theme-material .ag-icon-group::before {\n  content: \"\\f117\";\n}\n.ag-theme-material .ag-icon-last::before {\n  content: \"\\f118\";\n}\n.ag-theme-material .ag-icon-left::before {\n  content: \"\\f119\";\n}\n.ag-theme-material .ag-icon-linked::before {\n  content: \"\\f11a\";\n}\n.ag-theme-material .ag-icon-loading::before {\n  content: \"\\f11b\";\n}\n.ag-theme-material .ag-icon-maximize::before {\n  content: \"\\f11c\";\n}\n.ag-theme-material .ag-icon-menu::before {\n  content: \"\\f11d\";\n}\n.ag-theme-material .ag-icon-minimize::before {\n  content: \"\\f11e\";\n}\n.ag-theme-material .ag-icon-next::before {\n  content: \"\\f11f\";\n}\n.ag-theme-material .ag-icon-none::before {\n  content: \"\\f120\";\n}\n.ag-theme-material .ag-icon-not-allowed::before {\n  content: \"\\f121\";\n}\n.ag-theme-material .ag-icon-paste::before {\n  content: \"\\f122\";\n}\n.ag-theme-material .ag-icon-pin::before {\n  content: \"\\f123\";\n}\n.ag-theme-material .ag-icon-pivot::before {\n  content: \"\\f124\";\n}\n.ag-theme-material .ag-icon-previous::before {\n  content: \"\\f125\";\n}\n.ag-theme-material .ag-icon-right::before {\n  content: \"\\f128\";\n}\n.ag-theme-material .ag-icon-save::before {\n  content: \"\\f129\";\n}\n.ag-theme-material .ag-icon-small-down::before {\n  content: \"\\f12a\";\n}\n.ag-theme-material .ag-icon-small-left::before {\n  content: \"\\f12b\";\n}\n.ag-theme-material .ag-icon-small-right::before {\n  content: \"\\f12c\";\n}\n.ag-theme-material .ag-icon-small-up::before {\n  content: \"\\f12d\";\n}\n.ag-theme-material .ag-icon-tick::before {\n  content: \"\\f12e\";\n}\n.ag-theme-material .ag-icon-tree-closed::before {\n  content: \"\\f12f\";\n}\n.ag-theme-material .ag-icon-tree-indeterminate::before {\n  content: \"\\f130\";\n}\n.ag-theme-material .ag-icon-tree-open::before {\n  content: \"\\f131\";\n}\n.ag-theme-material .ag-icon-unlinked::before {\n  content: \"\\f132\";\n}\n.ag-theme-material .ag-icon-row-drag::before {\n  content: \"\\f116\";\n}\n.ag-theme-material .ag-left-arrow::before {\n  content: \"\\f119\";\n}\n.ag-theme-material .ag-right-arrow::before {\n  content: \"\\f128\";\n}\n.ag-theme-material .ag-root-wrapper {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-material [class^=ag-], .ag-theme-material [class^=ag-]:focus, .ag-theme-material [class^=ag-]:after, .ag-theme-material [class^=ag-]:before {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  outline: none;\n}\n.ag-theme-material [class^=ag-]::-ms-clear {\n  display: none;\n}\n.ag-theme-material .ag-checkbox .ag-input-wrapper,\n.ag-theme-material .ag-radio-button .ag-input-wrapper {\n  overflow: visible;\n}\n.ag-theme-material .ag-range-field .ag-input-wrapper {\n  height: 100%;\n}\n.ag-theme-material .ag-toggle-button {\n  -webkit-box-flex: 0;\n          flex: none;\n  width: unset;\n  min-width: unset;\n}\n.ag-theme-material .ag-ltr .ag-label-align-right .ag-label {\n  margin-left: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-label-align-right .ag-label {\n  margin-right: 8px;\n}\n\n.ag-theme-material input[class^=ag-] {\n  margin: 0;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-material textarea[class^=ag-],\n.ag-theme-material select[class^=ag-] {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-material input[class^=ag-]:not([type]),\n.ag-theme-material input[class^=ag-][type=text],\n.ag-theme-material input[class^=ag-][type=number],\n.ag-theme-material input[class^=ag-][type=tel],\n.ag-theme-material input[class^=ag-][type=date],\n.ag-theme-material input[class^=ag-][type=datetime-local],\n.ag-theme-material textarea[class^=ag-] {\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n}\n.ag-theme-material input[class^=ag-]:not([type]):disabled,\n.ag-theme-material input[class^=ag-][type=text]:disabled,\n.ag-theme-material input[class^=ag-][type=number]:disabled,\n.ag-theme-material input[class^=ag-][type=tel]:disabled,\n.ag-theme-material input[class^=ag-][type=date]:disabled,\n.ag-theme-material input[class^=ag-][type=datetime-local]:disabled,\n.ag-theme-material textarea[class^=ag-]:disabled {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  background-color: var(--ag-input-disabled-background-color);\n  border-color: var(--ag-input-disabled-border-color);\n}\n.ag-theme-material input[class^=ag-]:not([type]):focus,\n.ag-theme-material input[class^=ag-][type=text]:focus,\n.ag-theme-material input[class^=ag-][type=number]:focus,\n.ag-theme-material input[class^=ag-][type=tel]:focus,\n.ag-theme-material input[class^=ag-][type=date]:focus,\n.ag-theme-material input[class^=ag-][type=datetime-local]:focus,\n.ag-theme-material textarea[class^=ag-]:focus {\n  outline: none;\n  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material input[class^=ag-]:not([type]):invalid,\n.ag-theme-material input[class^=ag-][type=text]:invalid,\n.ag-theme-material input[class^=ag-][type=number]:invalid,\n.ag-theme-material input[class^=ag-][type=tel]:invalid,\n.ag-theme-material input[class^=ag-][type=date]:invalid,\n.ag-theme-material input[class^=ag-][type=datetime-local]:invalid,\n.ag-theme-material textarea[class^=ag-]:invalid {\n  border-width: 2px;\n  border-style: solid;\n  border-color: var(--ag-input-border-color-invalid);\n}\n.ag-theme-material input[class^=ag-][type=number] {\n  -moz-appearance: textfield;\n}\n.ag-theme-material input[class^=ag-][type=number]::-webkit-outer-spin-button, .ag-theme-material input[class^=ag-][type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.ag-theme-material input[class^=ag-][type=range] {\n  padding: 0;\n}\n.ag-theme-material input[class^=ag-][type=button]:focus, .ag-theme-material button[class^=ag-]:focus {\n  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n}\n.ag-theme-material .ag-drag-handle {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-list-item, .ag-theme-material .ag-virtual-list-item {\n  height: 32px;\n}\n.ag-theme-material .ag-keyboard-focus .ag-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-select-list {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.ag-theme-material .ag-list-item {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-theme-material .ag-list-item.ag-active-item {\n  background-color: #fafafa;\n  background-color: var(--ag-row-hover-color, #fafafa);\n}\n.ag-theme-material .ag-select-list-item {\n  padding-left: 4px;\n  padding-right: 4px;\n  cursor: default;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n.ag-theme-material .ag-select-list-item span {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.ag-theme-material .ag-select .ag-picker-field-wrapper {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  min-height: 32px;\n  cursor: default;\n}\n.ag-theme-material .ag-select.ag-disabled .ag-picker-field-wrapper:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ag-theme-material .ag-select:not(.ag-cell-editor) {\n  height: 32px;\n}\n.ag-theme-material .ag-select .ag-picker-field-display {\n  margin: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ag-theme-material .ag-select .ag-picker-field-icon {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-material .ag-select.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-material .ag-rich-select {\n  background-color: #fafafa;\n  background-color: var(--ag-control-panel-background-color, #fafafa);\n}\n.ag-theme-material .ag-rich-select-list {\n  width: 100%;\n  min-width: 200px;\n  height: 312px;\n}\n.ag-theme-material .ag-rich-select-value {\n  padding: 0 8px 0 24px;\n  height: 48px;\n}\n.ag-theme-material .ag-rich-select-virtual-list-item {\n  cursor: default;\n  height: 32px;\n}\n.ag-theme-material .ag-rich-select-virtual-list-item:hover {\n  background-color: #fafafa;\n  background-color: var(--ag-row-hover-color, #fafafa);\n}\n.ag-theme-material .ag-rich-select-row {\n  padding-left: 24px;\n}\n.ag-theme-material .ag-rich-select-row-selected {\n  background-color: #eee;\n  background-color: var(--ag-selected-row-background-color, #eee);\n}\n.ag-theme-material .ag-row-drag,\n.ag-theme-material .ag-selection-checkbox,\n.ag-theme-material .ag-group-expanded,\n.ag-theme-material .ag-group-contracted {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-ltr .ag-row-drag, .ag-theme-material .ag-ltr .ag-selection-checkbox, .ag-theme-material .ag-ltr .ag-group-expanded, .ag-theme-material .ag-ltr .ag-group-contracted {\n  margin-right: 24px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-drag, .ag-theme-material .ag-rtl .ag-selection-checkbox, .ag-theme-material .ag-rtl .ag-group-expanded, .ag-theme-material .ag-rtl .ag-group-contracted {\n  margin-left: 24px;\n}\n\n.ag-theme-material .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {\n  height: min(var(--ag-line-height, 46px), 46px);\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-box-flex: 0;\n          flex: none;\n}\n.ag-theme-material .ag-group-expanded,\n.ag-theme-material .ag-group-contracted {\n  cursor: pointer;\n}\n.ag-theme-material .ag-group-title-bar-icon {\n  cursor: pointer;\n  -webkit-box-flex: 0;\n          flex: none;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-ltr .ag-group-child-count {\n  margin-left: 2px;\n}\n\n.ag-theme-material .ag-rtl .ag-group-child-count {\n  margin-right: 2px;\n}\n\n.ag-theme-material .ag-group-title-bar {\n  background-color: #eee;\n  background-color: var(--ag-subheader-background-color, #eee);\n  padding: 8px;\n}\n.ag-theme-material .ag-group-toolbar {\n  padding: 8px;\n}\n.ag-theme-material .ag-disabled-group-title-bar, .ag-theme-material .ag-disabled-group-container {\n  opacity: 0.5;\n}\n.ag-theme-material .group-item {\n  margin: 4px 0;\n}\n.ag-theme-material .ag-label {\n  white-space: nowrap;\n}\n.ag-theme-material .ag-ltr .ag-label {\n  margin-right: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-label {\n  margin-left: 8px;\n}\n\n.ag-theme-material .ag-label-align-top .ag-label {\n  margin-bottom: 4px;\n}\n.ag-theme-material .ag-ltr .ag-slider-field, .ag-theme-material .ag-ltr .ag-angle-select-field {\n  margin-right: 16px;\n}\n\n.ag-theme-material .ag-rtl .ag-slider-field, .ag-theme-material .ag-rtl .ag-angle-select-field {\n  margin-left: 16px;\n}\n\n.ag-theme-material .ag-angle-select-parent-circle {\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  border: solid 1px;\n  border-color: #e2e2e2;\n  border-color: var(--ag-border-color, #e2e2e2);\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-material .ag-angle-select-child-circle {\n  top: 4px;\n  left: 12px;\n  width: 6px;\n  height: 6px;\n  margin-left: -3px;\n  margin-top: -4px;\n  border-radius: 3px;\n  background-color: rgba(0, 0, 0, 0.54);\n  background-color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-picker-field-wrapper {\n  border: 1px solid;\n  border-color: #e2e2e2;\n  border-color: var(--ag-border-color, #e2e2e2);\n  border-radius: 5px;\n}\n.ag-theme-material .ag-picker-field-wrapper:focus {\n  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n}\n.ag-theme-material .ag-picker-field-button {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-dialog.ag-color-dialog {\n  border-radius: 5px;\n}\n.ag-theme-material .ag-color-picker .ag-picker-field-display {\n  height: 18px;\n}\n.ag-theme-material .ag-color-panel {\n  padding: 8px;\n}\n.ag-theme-material .ag-spectrum-color {\n  background-color: rgb(255, 0, 0);\n  border-radius: 2px;\n}\n.ag-theme-material .ag-spectrum-tools {\n  padding: 10px;\n}\n.ag-theme-material .ag-spectrum-sat {\n  background-image: -webkit-gradient(linear, left top, right top, from(white), to(rgba(204, 154, 129, 0)));\n  background-image: linear-gradient(to right, white, rgba(204, 154, 129, 0));\n}\n.ag-theme-material .ag-spectrum-val {\n  background-image: -webkit-gradient(linear, left bottom, left top, from(black), to(rgba(204, 154, 129, 0)));\n  background-image: linear-gradient(to top, black, rgba(204, 154, 129, 0));\n}\n.ag-theme-material .ag-spectrum-dragger {\n  border-radius: 12px;\n  height: 12px;\n  width: 12px;\n  border: 1px solid white;\n  background: black;\n  -webkit-box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);\n          box-shadow: 0 0 2px 0px rgba(0, 0, 0, 0.24);\n}\n.ag-theme-material .ag-spectrum-hue-background {\n  border-radius: 2px;\n}\n.ag-theme-material .ag-spectrum-alpha-background {\n  border-radius: 2px;\n}\n.ag-theme-material .ag-spectrum-tool {\n  margin-bottom: 10px;\n  height: 11px;\n  border-radius: 2px;\n}\n.ag-theme-material .ag-spectrum-slider {\n  margin-top: -12px;\n  width: 13px;\n  height: 13px;\n  border-radius: 13px;\n  background-color: rgb(248, 248, 248);\n  -webkit-box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.37);\n}\n.ag-theme-material .ag-recent-color {\n  margin: 0 3px;\n}\n.ag-theme-material .ag-recent-color:first-child {\n  margin-left: 0;\n}\n.ag-theme-material .ag-recent-color:last-child {\n  margin-right: 0;\n}\n.ag-theme-material.ag-dnd-ghost {\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 2px;\n  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n  height: 56px !important;\n  line-height: 56px;\n  margin: 0;\n  padding: 0 16px;\n  -webkit-transform: translateY(16px);\n          transform: translateY(16px);\n}\n.ag-theme-material .ag-dnd-ghost-icon {\n  margin-right: 8px;\n  color: rgba(0, 0, 0, 0.87);\n  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));\n}\n.ag-theme-material .ag-popup-child:not(.ag-tooltip-custom) {\n  -webkit-box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);\n          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);\n}\n.ag-dragging-range-handle .ag-theme-material .ag-dialog, .ag-dragging-fill-handle .ag-theme-material .ag-dialog {\n  opacity: 0.7;\n  pointer-events: none;\n}\n.ag-theme-material .ag-dialog {\n  border-radius: 0px;\n}\n.ag-theme-material .ag-panel {\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-material .ag-panel-title-bar {\n  background-color: #fff;\n  background-color: var(--ag-header-background-color, #fff);\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));\n  height: 56px;\n  padding: 8px 24px;\n}\n.ag-theme-material .ag-ltr .ag-panel-title-bar-button {\n  margin-left: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-panel-title-bar-button {\n  margin-right: 8px;\n}\n\n.ag-theme-material .ag-tooltip {\n  background-color: #fff;\n  background-color: var(--ag-header-background-color, #fff);\n  color: rgba(0, 0, 0, 0.87);\n  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));\n  padding: 8px;\n  border-radius: 2px;\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n  white-space: normal;\n}\n.ag-theme-material .ag-tooltip.ag-tooltip-hiding {\n  opacity: 0;\n}\n.ag-theme-material .ag-tooltip-custom {\n  -webkit-transition: opacity 1s;\n  transition: opacity 1s;\n}\n.ag-theme-material .ag-tooltip-custom.ag-tooltip-hiding {\n  opacity: 0;\n}\n.ag-theme-material .ag-ltr .ag-column-select-indent-1 {\n  padding-left: 26px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-1 {\n  padding-right: 26px;\n}\n\n.ag-theme-material .ag-ltr .ag-column-select-indent-2 {\n  padding-left: 52px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-2 {\n  padding-right: 52px;\n}\n\n.ag-theme-material .ag-ltr .ag-column-select-indent-3 {\n  padding-left: 78px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-3 {\n  padding-right: 78px;\n}\n\n.ag-theme-material .ag-ltr .ag-column-select-indent-4 {\n  padding-left: 104px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-4 {\n  padding-right: 104px;\n}\n\n.ag-theme-material .ag-ltr .ag-column-select-indent-5 {\n  padding-left: 130px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-5 {\n  padding-right: 130px;\n}\n\n.ag-theme-material .ag-ltr .ag-column-select-indent-6 {\n  padding-left: 156px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-6 {\n  padding-right: 156px;\n}\n\n.ag-theme-material .ag-ltr .ag-column-select-indent-7 {\n  padding-left: 182px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-7 {\n  padding-right: 182px;\n}\n\n.ag-theme-material .ag-ltr .ag-column-select-indent-8 {\n  padding-left: 208px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-8 {\n  padding-right: 208px;\n}\n\n.ag-theme-material .ag-ltr .ag-column-select-indent-9 {\n  padding-left: 234px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-indent-9 {\n  padding-right: 234px;\n}\n\n.ag-theme-material .ag-column-select-header-icon {\n  cursor: pointer;\n}\n.ag-theme-material .ag-keyboard-focus .ag-column-select-header-icon:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-column-select-header-icon:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-ltr .ag-column-group-icons:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-header-icon:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-header-checkbox:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-checkbox:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-material .ag-ltr .ag-column-select-column-label:not(:last-child) {\n  margin-right: 16px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-group-icons:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-header-icon:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-header-checkbox:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-header-filter-wrapper:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-checkbox:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-column-drag-handle:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-column-group-drag-handle:not(:last-child), .ag-theme-material .ag-rtl .ag-column-select-column-label:not(:last-child) {\n  margin-left: 16px;\n}\n\n.ag-theme-material .ag-keyboard-focus .ag-column-select-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-column-select-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-column-select-column-group:not(:last-child),\n.ag-theme-material .ag-column-select-column:not(:last-child) {\n  margin-bottom: 14px;\n}\n.ag-theme-material .ag-column-select-column-readonly,\n.ag-theme-material .ag-column-select-column-group-readonly {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  pointer-events: none;\n}\n.ag-theme-material .ag-ltr .ag-column-select-add-group-indent {\n  margin-left: 34px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-select-add-group-indent {\n  margin-right: 34px;\n}\n\n.ag-theme-material .ag-column-select-virtual-list-viewport {\n  padding: 8px 0px;\n}\n.ag-theme-material .ag-column-select-virtual-list-item {\n  padding: 0 12px;\n}\n.ag-theme-material .ag-rtl {\n  text-align: right;\n}\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {\n  padding-left: 66px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-1 {\n  padding-right: 66px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-1 {\n  padding-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-1 {\n  padding-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-1 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-1 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {\n  padding-left: 108px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-2 {\n  padding-right: 108px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-2 {\n  padding-left: 84px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-2 {\n  padding-right: 84px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-2 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-2 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {\n  padding-left: 150px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-3 {\n  padding-right: 150px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-3 {\n  padding-left: 126px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-3 {\n  padding-right: 126px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-3 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-3 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {\n  padding-left: 192px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-4 {\n  padding-right: 192px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-4 {\n  padding-left: 168px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-4 {\n  padding-right: 168px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-4 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-4 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {\n  padding-left: 234px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-5 {\n  padding-right: 234px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-5 {\n  padding-left: 210px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-5 {\n  padding-right: 210px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-5 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-5 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {\n  padding-left: 276px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-6 {\n  padding-right: 276px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-6 {\n  padding-left: 252px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-6 {\n  padding-right: 252px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-6 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-6 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {\n  padding-left: 318px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-7 {\n  padding-right: 318px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-7 {\n  padding-left: 294px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-7 {\n  padding-right: 294px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-7 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-7 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {\n  padding-left: 360px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-8 {\n  padding-right: 360px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-8 {\n  padding-left: 336px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-8 {\n  padding-right: 336px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-8 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-8 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {\n  padding-left: 402px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-9 {\n  padding-right: 402px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-9 {\n  padding-left: 378px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-9 {\n  padding-right: 378px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-9 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-9 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {\n  padding-left: 444px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-10 {\n  padding-right: 444px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-10 {\n  padding-left: 420px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-10 {\n  padding-right: 420px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-10 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-10 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {\n  padding-left: 486px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-11 {\n  padding-right: 486px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-11 {\n  padding-left: 462px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-11 {\n  padding-right: 462px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-11 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-11 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {\n  padding-left: 528px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-12 {\n  padding-right: 528px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-12 {\n  padding-left: 504px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-12 {\n  padding-right: 504px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-12 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-12 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {\n  padding-left: 570px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-13 {\n  padding-right: 570px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-13 {\n  padding-left: 546px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-13 {\n  padding-right: 546px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-13 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-13 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {\n  padding-left: 612px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-14 {\n  padding-right: 612px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-14 {\n  padding-left: 588px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-14 {\n  padding-right: 588px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-14 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-14 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {\n  padding-left: 654px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-15 {\n  padding-right: 654px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-15 {\n  padding-left: 630px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-15 {\n  padding-right: 630px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-15 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-15 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {\n  padding-left: 696px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-16 {\n  padding-right: 696px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-16 {\n  padding-left: 672px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-16 {\n  padding-right: 672px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-16 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-16 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {\n  padding-left: 738px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-17 {\n  padding-right: 738px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-17 {\n  padding-left: 714px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-17 {\n  padding-right: 714px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-17 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-17 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {\n  padding-left: 780px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-18 {\n  padding-right: 780px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-18 {\n  padding-left: 756px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-18 {\n  padding-right: 756px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-18 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-18 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {\n  padding-left: 822px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-19 {\n  padding-right: 822px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-19 {\n  padding-left: 798px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-19 {\n  padding-right: 798px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-19 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-19 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {\n  padding-left: 864px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-20 {\n  padding-right: 864px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-20 {\n  padding-left: 840px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-20 {\n  padding-right: 840px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-20 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-20 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {\n  padding-left: 906px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-21 {\n  padding-right: 906px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-21 {\n  padding-left: 882px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-21 {\n  padding-right: 882px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-21 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-21 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {\n  padding-left: 948px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-22 {\n  padding-right: 948px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-22 {\n  padding-left: 924px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-22 {\n  padding-right: 924px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-22 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-22 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {\n  padding-left: 990px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-23 {\n  padding-right: 990px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-23 {\n  padding-left: 966px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-23 {\n  padding-right: 966px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-23 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-23 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {\n  padding-left: 1032px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-24 {\n  padding-right: 1032px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-24 {\n  padding-left: 1008px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-24 {\n  padding-right: 1008px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-24 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-24 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {\n  padding-left: 1074px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-25 {\n  padding-right: 1074px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-25 {\n  padding-left: 1050px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-25 {\n  padding-right: 1050px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-25 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-25 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {\n  padding-left: 1116px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-26 {\n  padding-right: 1116px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-26 {\n  padding-left: 1092px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-26 {\n  padding-right: 1092px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-26 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-26 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {\n  padding-left: 1158px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-27 {\n  padding-right: 1158px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-27 {\n  padding-left: 1134px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-27 {\n  padding-right: 1134px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-27 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-27 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {\n  padding-left: 1200px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-28 {\n  padding-right: 1200px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-28 {\n  padding-left: 1176px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-28 {\n  padding-right: 1176px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-28 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-28 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {\n  padding-left: 1242px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-29 {\n  padding-right: 1242px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-29 {\n  padding-left: 1218px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-29 {\n  padding-right: 1218px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-29 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-29 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {\n  padding-left: 1284px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-30 {\n  padding-right: 1284px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-30 {\n  padding-left: 1260px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-30 {\n  padding-right: 1260px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-30 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-30 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {\n  padding-left: 1326px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-31 {\n  padding-right: 1326px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-31 {\n  padding-left: 1302px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-31 {\n  padding-right: 1302px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-31 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-31 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {\n  padding-left: 1368px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-32 {\n  padding-right: 1368px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-32 {\n  padding-left: 1344px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-32 {\n  padding-right: 1344px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-32 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-32 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {\n  padding-left: 1410px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-33 {\n  padding-right: 1410px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-33 {\n  padding-left: 1386px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-33 {\n  padding-right: 1386px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-33 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-33 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {\n  padding-left: 1452px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-34 {\n  padding-right: 1452px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-34 {\n  padding-left: 1428px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-34 {\n  padding-right: 1428px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-34 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-34 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {\n  padding-left: 1494px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-35 {\n  padding-right: 1494px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-35 {\n  padding-left: 1470px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-35 {\n  padding-right: 1470px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-35 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-35 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {\n  padding-left: 1536px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-36 {\n  padding-right: 1536px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-36 {\n  padding-left: 1512px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-36 {\n  padding-right: 1512px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-36 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-36 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {\n  padding-left: 1578px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-37 {\n  padding-right: 1578px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-37 {\n  padding-left: 1554px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-37 {\n  padding-right: 1554px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-37 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-37 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {\n  padding-left: 1620px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-38 {\n  padding-right: 1620px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-38 {\n  padding-left: 1596px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-38 {\n  padding-right: 1596px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-38 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-38 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {\n  padding-left: 1662px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-39 {\n  padding-right: 1662px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-39 {\n  padding-left: 1638px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-39 {\n  padding-right: 1638px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-39 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-39 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {\n  padding-left: 1704px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-40 {\n  padding-right: 1704px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-40 {\n  padding-left: 1680px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-40 {\n  padding-right: 1680px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-40 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-40 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {\n  padding-left: 1746px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-41 {\n  padding-right: 1746px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-41 {\n  padding-left: 1722px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-41 {\n  padding-right: 1722px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-41 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-41 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {\n  padding-left: 1788px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-42 {\n  padding-right: 1788px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-42 {\n  padding-left: 1764px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-42 {\n  padding-right: 1764px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-42 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-42 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {\n  padding-left: 1830px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-43 {\n  padding-right: 1830px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-43 {\n  padding-left: 1806px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-43 {\n  padding-right: 1806px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-43 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-43 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {\n  padding-left: 1872px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-44 {\n  padding-right: 1872px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-44 {\n  padding-left: 1848px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-44 {\n  padding-right: 1848px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-44 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-44 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {\n  padding-left: 1914px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-45 {\n  padding-right: 1914px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-45 {\n  padding-left: 1890px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-45 {\n  padding-right: 1890px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-45 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-45 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {\n  padding-left: 1956px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-46 {\n  padding-right: 1956px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-46 {\n  padding-left: 1932px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-46 {\n  padding-right: 1932px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-46 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-46 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {\n  padding-left: 1998px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-47 {\n  padding-right: 1998px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-47 {\n  padding-left: 1974px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-47 {\n  padding-right: 1974px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-47 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-47 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {\n  padding-left: 2040px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-48 {\n  padding-right: 2040px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-48 {\n  padding-left: 2016px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-48 {\n  padding-right: 2016px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-48 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-48 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {\n  padding-left: 2082px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-49 {\n  padding-right: 2082px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-49 {\n  padding-left: 2058px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-49 {\n  padding-right: 2058px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-49 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-49 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {\n  padding-left: 2124px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-50 {\n  padding-right: 2124px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-50 {\n  padding-left: 2100px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-50 {\n  padding-right: 2100px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-50 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-50 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {\n  padding-left: 2166px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-51 {\n  padding-right: 2166px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-51 {\n  padding-left: 2142px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-51 {\n  padding-right: 2142px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-51 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-51 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {\n  padding-left: 2208px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-52 {\n  padding-right: 2208px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-52 {\n  padding-left: 2184px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-52 {\n  padding-right: 2184px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-52 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-52 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {\n  padding-left: 2250px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-53 {\n  padding-right: 2250px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-53 {\n  padding-left: 2226px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-53 {\n  padding-right: 2226px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-53 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-53 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {\n  padding-left: 2292px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-54 {\n  padding-right: 2292px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-54 {\n  padding-left: 2268px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-54 {\n  padding-right: 2268px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-54 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-54 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {\n  padding-left: 2334px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-55 {\n  padding-right: 2334px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-55 {\n  padding-left: 2310px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-55 {\n  padding-right: 2310px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-55 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-55 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {\n  padding-left: 2376px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-56 {\n  padding-right: 2376px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-56 {\n  padding-left: 2352px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-56 {\n  padding-right: 2352px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-56 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-56 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {\n  padding-left: 2418px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-57 {\n  padding-right: 2418px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-57 {\n  padding-left: 2394px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-57 {\n  padding-right: 2394px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-57 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-57 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {\n  padding-left: 2460px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-58 {\n  padding-right: 2460px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-58 {\n  padding-left: 2436px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-58 {\n  padding-right: 2436px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-58 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-58 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {\n  padding-left: 2502px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-59 {\n  padding-right: 2502px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-59 {\n  padding-left: 2478px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-59 {\n  padding-right: 2478px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-59 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-59 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {\n  padding-left: 2544px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-60 {\n  padding-right: 2544px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-60 {\n  padding-left: 2520px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-60 {\n  padding-right: 2520px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-60 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-60 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {\n  padding-left: 2586px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-61 {\n  padding-right: 2586px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-61 {\n  padding-left: 2562px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-61 {\n  padding-right: 2562px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-61 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-61 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {\n  padding-left: 2628px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-62 {\n  padding-right: 2628px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-62 {\n  padding-left: 2604px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-62 {\n  padding-right: 2604px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-62 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-62 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {\n  padding-left: 2670px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-63 {\n  padding-right: 2670px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-63 {\n  padding-left: 2646px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-63 {\n  padding-right: 2646px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-63 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-63 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {\n  padding-left: 2712px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-64 {\n  padding-right: 2712px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-64 {\n  padding-left: 2688px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-64 {\n  padding-right: 2688px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-64 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-64 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {\n  padding-left: 2754px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-65 {\n  padding-right: 2754px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-65 {\n  padding-left: 2730px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-65 {\n  padding-right: 2730px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-65 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-65 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {\n  padding-left: 2796px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-66 {\n  padding-right: 2796px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-66 {\n  padding-left: 2772px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-66 {\n  padding-right: 2772px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-66 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-66 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {\n  padding-left: 2838px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-67 {\n  padding-right: 2838px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-67 {\n  padding-left: 2814px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-67 {\n  padding-right: 2814px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-67 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-67 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {\n  padding-left: 2880px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-68 {\n  padding-right: 2880px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-68 {\n  padding-left: 2856px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-68 {\n  padding-right: 2856px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-68 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-68 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {\n  padding-left: 2922px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-69 {\n  padding-right: 2922px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-69 {\n  padding-left: 2898px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-69 {\n  padding-right: 2898px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-69 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-69 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {\n  padding-left: 2964px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-70 {\n  padding-right: 2964px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-70 {\n  padding-left: 2940px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-70 {\n  padding-right: 2940px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-70 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-70 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {\n  padding-left: 3006px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-71 {\n  padding-right: 3006px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-71 {\n  padding-left: 2982px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-71 {\n  padding-right: 2982px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-71 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-71 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {\n  padding-left: 3048px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-72 {\n  padding-right: 3048px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-72 {\n  padding-left: 3024px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-72 {\n  padding-right: 3024px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-72 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-72 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {\n  padding-left: 3090px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-73 {\n  padding-right: 3090px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-73 {\n  padding-left: 3066px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-73 {\n  padding-right: 3066px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-73 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-73 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {\n  padding-left: 3132px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-74 {\n  padding-right: 3132px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-74 {\n  padding-left: 3108px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-74 {\n  padding-right: 3108px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-74 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-74 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {\n  padding-left: 3174px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-75 {\n  padding-right: 3174px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-75 {\n  padding-left: 3150px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-75 {\n  padding-right: 3150px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-75 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-75 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {\n  padding-left: 3216px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-76 {\n  padding-right: 3216px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-76 {\n  padding-left: 3192px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-76 {\n  padding-right: 3192px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-76 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-76 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {\n  padding-left: 3258px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-77 {\n  padding-right: 3258px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-77 {\n  padding-left: 3234px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-77 {\n  padding-right: 3234px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-77 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-77 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {\n  padding-left: 3300px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-78 {\n  padding-right: 3300px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-78 {\n  padding-left: 3276px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-78 {\n  padding-right: 3276px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-78 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-78 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {\n  padding-left: 3342px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-79 {\n  padding-right: 3342px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-79 {\n  padding-left: 3318px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-79 {\n  padding-right: 3318px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-79 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-79 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {\n  padding-left: 3384px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-80 {\n  padding-right: 3384px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-80 {\n  padding-left: 3360px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-80 {\n  padding-right: 3360px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-80 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-80 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {\n  padding-left: 3426px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-81 {\n  padding-right: 3426px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-81 {\n  padding-left: 3402px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-81 {\n  padding-right: 3402px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-81 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-81 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {\n  padding-left: 3468px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-82 {\n  padding-right: 3468px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-82 {\n  padding-left: 3444px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-82 {\n  padding-right: 3444px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-82 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-82 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {\n  padding-left: 3510px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-83 {\n  padding-right: 3510px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-83 {\n  padding-left: 3486px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-83 {\n  padding-right: 3486px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-83 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-83 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {\n  padding-left: 3552px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-84 {\n  padding-right: 3552px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-84 {\n  padding-left: 3528px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-84 {\n  padding-right: 3528px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-84 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-84 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {\n  padding-left: 3594px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-85 {\n  padding-right: 3594px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-85 {\n  padding-left: 3570px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-85 {\n  padding-right: 3570px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-85 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-85 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {\n  padding-left: 3636px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-86 {\n  padding-right: 3636px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-86 {\n  padding-left: 3612px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-86 {\n  padding-right: 3612px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-86 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-86 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {\n  padding-left: 3678px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-87 {\n  padding-right: 3678px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-87 {\n  padding-left: 3654px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-87 {\n  padding-right: 3654px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-87 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-87 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {\n  padding-left: 3720px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-88 {\n  padding-right: 3720px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-88 {\n  padding-left: 3696px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-88 {\n  padding-right: 3696px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-88 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-88 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {\n  padding-left: 3762px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-89 {\n  padding-right: 3762px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-89 {\n  padding-left: 3738px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-89 {\n  padding-right: 3738px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-89 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-89 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {\n  padding-left: 3804px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-90 {\n  padding-right: 3804px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-90 {\n  padding-left: 3780px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-90 {\n  padding-right: 3780px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-90 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-90 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {\n  padding-left: 3846px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-91 {\n  padding-right: 3846px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-91 {\n  padding-left: 3822px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-91 {\n  padding-right: 3822px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-91 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-91 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {\n  padding-left: 3888px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-92 {\n  padding-right: 3888px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-92 {\n  padding-left: 3864px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-92 {\n  padding-right: 3864px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-92 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-92 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {\n  padding-left: 3930px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-93 {\n  padding-right: 3930px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-93 {\n  padding-left: 3906px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-93 {\n  padding-right: 3906px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-93 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-93 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {\n  padding-left: 3972px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-94 {\n  padding-right: 3972px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-94 {\n  padding-left: 3948px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-94 {\n  padding-right: 3948px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-94 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-94 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {\n  padding-left: 4014px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-95 {\n  padding-right: 4014px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-95 {\n  padding-left: 3990px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-95 {\n  padding-right: 3990px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-95 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-95 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {\n  padding-left: 4056px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-96 {\n  padding-right: 4056px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-96 {\n  padding-left: 4032px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-96 {\n  padding-right: 4032px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-96 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-96 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {\n  padding-left: 4098px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-97 {\n  padding-right: 4098px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-97 {\n  padding-left: 4074px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-97 {\n  padding-right: 4074px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-97 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-97 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {\n  padding-left: 4140px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-98 {\n  padding-right: 4140px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-98 {\n  padding-left: 4116px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-98 {\n  padding-right: 4116px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-98 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-98 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {\n  padding-left: 4182px;\n}\n\n.ag-theme-material .ag-rtl .ag-row > .ag-cell-wrapper.ag-row-group-indent-99 {\n  padding-right: 4182px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-indent-99 {\n  padding-left: 4158px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-indent-99 {\n  padding-right: 4158px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-level-99 .ag-pivot-leaf-group {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-level-99 .ag-pivot-leaf-group {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-ltr .ag-row-group-leaf-indent {\n  margin-left: 42px;\n}\n\n.ag-theme-material .ag-rtl .ag-row-group-leaf-indent {\n  margin-right: 42px;\n}\n\n.ag-theme-material .ag-value-change-delta {\n  padding-right: 2px;\n}\n.ag-theme-material .ag-value-change-delta-up {\n  color: #43a047;\n  color: var(--ag-value-change-delta-up-color, #43a047);\n}\n.ag-theme-material .ag-value-change-delta-down {\n  color: #e53935;\n  color: var(--ag-value-change-delta-down-color, #e53935);\n}\n.ag-theme-material .ag-value-change-value {\n  background-color: transparent;\n  border-radius: 1px;\n  padding-left: 1px;\n  padding-right: 1px;\n  -webkit-transition: background-color 1s;\n  transition: background-color 1s;\n}\n.ag-theme-material .ag-value-change-value-highlight {\n  background-color: #00acc1;\n  background-color: var(--ag-value-change-value-highlight-background-color, #00acc1);\n  -webkit-transition: background-color 0.1s;\n  transition: background-color 0.1s;\n}\n.ag-theme-material .ag-cell-data-changed {\n  background-color: #00acc1 !important;\n  background-color: var(--ag-value-change-value-highlight-background-color, #00acc1) !important;\n}\n.ag-theme-material .ag-cell-data-changed-animation {\n  background-color: transparent;\n}\n.ag-theme-material .ag-cell-highlight {\n  background-color: #fce4ec !important;\n  background-color: var(--ag-range-selection-highlight-color, #fce4ec) !important;\n}\n.ag-theme-material .ag-row {\n  height: 48px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  color: rgba(0, 0, 0, 0.87);\n  color: var(--ag-data-color, var(--ag-foreground-color, rgba(0, 0, 0, 0.87)));\n  border-width: 1px;\n  border-color: #e2e2e2;\n  border-color: var(--ag-row-border-color, var(--ag-secondary-border-color, var(--ag-border-color, #e2e2e2)));\n  border-bottom-style: solid;\n}\n.ag-theme-material .ag-row-highlight-above::after, .ag-theme-material .ag-row-highlight-below::after {\n  content: \"\";\n  position: absolute;\n  width: calc(100% - 1px);\n  height: 1px;\n  background-color: #3f51b5;\n  background-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n  left: 1px;\n}\n.ag-theme-material .ag-row-highlight-above::after {\n  top: -1px;\n}\n.ag-theme-material .ag-row-highlight-above.ag-row-first::after {\n  top: 0;\n}\n.ag-theme-material .ag-row-highlight-below::after {\n  bottom: 0px;\n}\n.ag-theme-material .ag-row-odd {\n  background-color: var(--ag-odd-row-background-color);\n}\n.ag-theme-material .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {\n  border-right: solid 1px;\n  border-right-color: #e2e2e2;\n  border-right-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {\n  border-left: solid 1px;\n  border-left-color: #e2e2e2;\n  border-left-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-row-hover {\n  background-color: #fafafa;\n  background-color: var(--ag-row-hover-color, #fafafa);\n}\n.ag-theme-material .ag-column-hover {\n  background-color: #fafafa;\n  background-color: var(--ag-column-hover-color, #fafafa);\n}\n.ag-theme-material .ag-ltr .ag-right-aligned-cell {\n  text-align: right;\n}\n\n.ag-theme-material .ag-rtl .ag-right-aligned-cell {\n  text-align: left;\n}\n\n.ag-theme-material .ag-ltr .ag-right-aligned-cell .ag-cell-value, .ag-theme-material .ag-ltr .ag-right-aligned-cell .ag-group-value {\n  margin-left: auto;\n}\n\n.ag-theme-material .ag-rtl .ag-right-aligned-cell .ag-cell-value, .ag-theme-material .ag-rtl .ag-right-aligned-cell .ag-group-value {\n  margin-right: auto;\n}\n\n.ag-theme-material .ag-cell, .ag-theme-material .ag-full-width-row .ag-cell-wrapper.ag-row-group {\n  border: 1px solid transparent;\n  line-height: min(var(--ag-line-height, 46px), 46px);\n  padding-left: 23px;\n  padding-right: 23px;\n  -webkit-font-smoothing: subpixel-antialiased;\n}\n.ag-theme-material .ag-row > .ag-cell-wrapper {\n  padding-left: 23px;\n  padding-right: 23px;\n}\n.ag-theme-material .ag-row-dragging {\n  cursor: move;\n  opacity: 0.5;\n}\n.ag-theme-material .ag-cell-inline-editing {\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 2px;\n  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  padding: 0;\n  height: 48px;\n  background-color: #fafafa;\n  background-color: var(--ag-control-panel-background-color, #fafafa);\n}\n.ag-theme-material .ag-popup-editor {\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 2px;\n  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  background-color: #fafafa;\n  background-color: var(--ag-control-panel-background-color, #fafafa);\n  padding: 0;\n}\n.ag-theme-material .ag-large-text-input {\n  height: auto;\n  padding: 24px;\n}\n.ag-theme-material .ag-details-row {\n  padding: 40px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n}\n.ag-theme-material .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-material .ag-layout-auto-height .ag-center-cols-container, .ag-theme-material .ag-layout-print .ag-center-cols-clipper, .ag-theme-material .ag-layout-print .ag-center-cols-container {\n  min-height: 50px;\n}\n.ag-theme-material .ag-overlay-loading-wrapper {\n  background-color: rgba(255, 255, 255, 0.66);\n  background-color: var(--ag-modal-overlay-background-color, rgba(255, 255, 255, 0.66));\n}\n.ag-theme-material .ag-overlay-loading-center {\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 2px;\n  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  padding: 8px;\n}\n.ag-theme-material .ag-overlay-no-rows-wrapper.ag-layout-auto-height {\n  padding-top: 30px;\n}\n.ag-theme-material .ag-loading {\n  padding-left: 24px;\n  display: -webkit-box;\n  display: flex;\n  height: 100%;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-material .ag-loading-icon {\n  padding-right: 24px;\n}\n.ag-theme-material .ag-icon-loading {\n  -webkit-animation-name: spin;\n          animation-name: spin;\n  -webkit-animation-duration: 1000ms;\n          animation-duration: 1000ms;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n@-webkit-keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes spin {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.ag-theme-material .ag-floating-top {\n  border-bottom: solid 1px;\n  border-bottom-color: #e2e2e2;\n  border-bottom-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-floating-bottom {\n  border-top: solid 1px;\n  border-top-color: #e2e2e2;\n  border-top-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-ltr .ag-cell {\n  border-right: solid transparent;\n}\n\n.ag-theme-material .ag-rtl .ag-cell {\n  border-left: solid transparent;\n}\n\n.ag-theme-material .ag-ltr .ag-cell {\n  border-right-width: 1px;\n}\n\n.ag-theme-material .ag-rtl .ag-cell {\n  border-left-width: 1px;\n}\n\n.ag-theme-material .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {\n  border-left: solid 1px;\n  border-left-color: #e2e2e2;\n  border-left-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {\n  border-right: solid 1px;\n  border-right-color: #e2e2e2;\n  border-right-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-row-selected {\n  background-color: #eee;\n  background-color: var(--ag-selected-row-background-color, #eee);\n}\n.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus),\n.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing) {\n  background-color: rgba(122, 134, 203, 0.1);\n  background-color: var(--ag-range-selection-background-color, rgba(122, 134, 203, 0.1));\n}\n.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart,\n.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart {\n  background-color: rgba(0, 88, 255, 0.1) !important;\n  background-color: var(--ag-range-selection-chart-background-color, rgba(0, 88, 255, 0.1)) !important;\n}\n.ag-theme-material .ag-cell-range-selected:not(.ag-cell-focus).ag-cell-range-chart.ag-cell-range-chart-category,\n.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-single-cell:not(.ag-cell-inline-editing).ag-cell-range-chart.ag-cell-range-chart-category {\n  background-color: rgba(0, 255, 132, 0.1) !important;\n  background-color: var(--ag-range-selection-chart-category-background-color, rgba(0, 255, 132, 0.1)) !important;\n}\n.ag-theme-material .ag-cell-range-selected-1:not(.ag-cell-focus),\n.ag-theme-material .ag-root:not(.ag-context-menu-open) .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-1:not(.ag-cell-inline-editing) {\n  background-color: rgba(122, 134, 203, 0.1);\n  background-color: var(--ag-range-selection-background-color-1, var(--ag-range-selection-background-color, rgba(122, 134, 203, 0.1)));\n}\n.ag-theme-material .ag-cell-range-selected-2:not(.ag-cell-focus),\n.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-2 {\n  background-color: rgba(122, 134, 203, 0.19);\n  background-color: var(--ag-range-selection-background-color-2, rgba(122, 134, 203, 0.19));\n}\n.ag-theme-material .ag-cell-range-selected-3:not(.ag-cell-focus),\n.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-3 {\n  background-color: rgba(122, 134, 203, 0.271);\n  background-color: var(--ag-range-selection-background-color-3, rgba(122, 134, 203, 0.271));\n}\n.ag-theme-material .ag-cell-range-selected-4:not(.ag-cell-focus),\n.ag-theme-material .ag-body-viewport:not(.ag-has-focus) .ag-cell-range-selected-4 {\n  background-color: rgba(122, 134, 203, 0.3439);\n  background-color: var(--ag-range-selection-background-color-4, rgba(122, 134, 203, 0.3439));\n}\n.ag-theme-material .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-top {\n  border-top-color: #3f51b5;\n  border-top-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-right {\n  border-right-color: #3f51b5;\n  border-right-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-bottom {\n  border-bottom-color: #3f51b5;\n  border-bottom-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-cell.ag-cell-range-selected:not(.ag-cell-range-single-cell).ag-cell-range-left {\n  border-left-color: #3f51b5;\n  border-left-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-material .ag-ltr .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-material .ag-ltr .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,\n.ag-theme-material .ag-ltr .ag-cell-range-single-cell,\n.ag-theme-material .ag-ltr .ag-cell-range-single-cell.ag-cell-range-handle, .ag-theme-material .ag-rtl .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-material .ag-rtl .ag-context-menu-open .ag-cell-focus:not(.ag-cell-range-selected),\n.ag-theme-material .ag-rtl .ag-has-focus .ag-full-width-row.ag-row-focus .ag-cell-wrapper.ag-row-group,\n.ag-theme-material .ag-rtl .ag-cell-range-single-cell,\n.ag-theme-material .ag-rtl .ag-cell-range-single-cell.ag-cell-range-handle {\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n  outline: initial;\n}\n.ag-theme-material .ag-cell.ag-selection-fill-top,\n.ag-theme-material .ag-cell.ag-selection-fill-top.ag-cell-range-selected {\n  border-top: 1px dashed;\n  border-top-color: #3f51b5;\n  border-top-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-ltr .ag-cell.ag-selection-fill-right, .ag-theme-material .ag-ltr .ag-cell.ag-selection-fill-right.ag-cell-range-selected {\n  border-right: 1px dashed;\n  border-right-color: #3f51b5;\n  border-right-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n\n.ag-theme-material .ag-rtl .ag-cell.ag-selection-fill-right, .ag-theme-material .ag-rtl .ag-cell.ag-selection-fill-right.ag-cell-range-selected {\n  border-left: 1px dashed;\n  border-left-color: #3f51b5;\n  border-left-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n\n.ag-theme-material .ag-cell.ag-selection-fill-bottom,\n.ag-theme-material .ag-cell.ag-selection-fill-bottom.ag-cell-range-selected {\n  border-bottom: 1px dashed;\n  border-bottom-color: #3f51b5;\n  border-bottom-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-ltr .ag-cell.ag-selection-fill-left, .ag-theme-material .ag-ltr .ag-cell.ag-selection-fill-left.ag-cell-range-selected {\n  border-left: 1px dashed;\n  border-left-color: #3f51b5;\n  border-left-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n\n.ag-theme-material .ag-rtl .ag-cell.ag-selection-fill-left, .ag-theme-material .ag-rtl .ag-cell.ag-selection-fill-left.ag-cell-range-selected {\n  border-right: 1px dashed;\n  border-right-color: #3f51b5;\n  border-right-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n\n.ag-theme-material .ag-range-handle, .ag-theme-material .ag-fill-handle {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  bottom: -1px;\n  background-color: #3f51b5;\n  background-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-ltr .ag-range-handle, .ag-theme-material .ag-ltr .ag-fill-handle {\n  right: -1px;\n}\n\n.ag-theme-material .ag-rtl .ag-range-handle, .ag-theme-material .ag-rtl .ag-fill-handle {\n  left: -1px;\n}\n\n.ag-theme-material .ag-fill-handle {\n  cursor: cell;\n}\n.ag-theme-material .ag-range-handle {\n  cursor: nwse-resize;\n}\n.ag-theme-material .ag-cell-inline-editing {\n  border-color: #3f51b5 !important;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5)) !important;\n}\n.ag-theme-material .ag-menu {\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 2px;\n  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  padding: 0;\n}\n.ag-theme-material .ag-menu-list {\n  cursor: default;\n  padding: 8px 0;\n}\n.ag-theme-material .ag-menu-separator {\n  height: 17px;\n}\n.ag-theme-material .ag-menu-separator-part::after {\n  content: \"\";\n  display: block;\n  border-top: solid 1px;\n  border-top-color: #e2e2e2;\n  border-top-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-menu-option-active, .ag-theme-material .ag-compact-menu-option-active {\n  background-color: #fafafa;\n  background-color: var(--ag-row-hover-color, #fafafa);\n}\n.ag-theme-material .ag-menu-option-part, .ag-theme-material .ag-compact-menu-option-part {\n  line-height: 18px;\n  padding: 10px 0;\n}\n.ag-theme-material .ag-menu-option-disabled, .ag-theme-material .ag-compact-menu-option-disabled {\n  opacity: 0.5;\n}\n.ag-theme-material .ag-menu-option-icon, .ag-theme-material .ag-compact-menu-option-icon {\n  width: 18px;\n}\n.ag-theme-material .ag-ltr .ag-menu-option-icon, .ag-theme-material .ag-ltr .ag-compact-menu-option-icon {\n  padding-left: 16px;\n}\n\n.ag-theme-material .ag-rtl .ag-menu-option-icon, .ag-theme-material .ag-rtl .ag-compact-menu-option-icon {\n  padding-right: 16px;\n}\n\n.ag-theme-material .ag-menu-option-text, .ag-theme-material .ag-compact-menu-option-text {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.ag-theme-material .ag-ltr .ag-menu-option-shortcut, .ag-theme-material .ag-ltr .ag-compact-menu-option-shortcut {\n  padding-right: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-menu-option-shortcut, .ag-theme-material .ag-rtl .ag-compact-menu-option-shortcut {\n  padding-left: 8px;\n}\n\n.ag-theme-material .ag-menu-option-popup-pointer, .ag-theme-material .ag-compact-menu-option-popup-pointer {\n  padding-right: 8px;\n}\n.ag-theme-material .ag-tabs {\n  min-width: 220px;\n}\n.ag-theme-material .ag-tabs-header {\n  width: 100%;\n  display: -webkit-box;\n  display: flex;\n}\n.ag-theme-material .ag-tab {\n  border-bottom: 2px solid transparent;\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-flex: 0;\n          flex: none;\n  -webkit-box-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n          justify-content: center;\n  cursor: pointer;\n  -webkit-box-flex: 1;\n          flex: 1 1 auto;\n}\n.ag-theme-material .ag-keyboard-focus .ag-tab:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-tab:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-tab-selected {\n  border-bottom-color: #3f51b5;\n  border-bottom-color: var(--ag-selected-tab-underline-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-menu-header {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-filter-separator {\n  border-top: solid 1px;\n  border-top-color: #e2e2e2;\n  border-top-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-menu:not(.ag-tabs) .ag-filter-select {\n  min-width: 155px;\n}\n.ag-theme-material .ag-tabs .ag-filter-select {\n  min-width: 194px;\n}\n.ag-theme-material .ag-filter-select .ag-picker-field-wrapper {\n  width: 0;\n}\n.ag-theme-material .ag-filter-condition-operator {\n  height: 17px;\n}\n.ag-theme-material .ag-ltr .ag-filter-condition-operator-or {\n  margin-left: 16px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-condition-operator-or {\n  margin-right: 16px;\n}\n\n.ag-theme-material .ag-set-filter-select-all {\n  padding-top: 16px;\n}\n.ag-theme-material .ag-set-filter-list, .ag-theme-material .ag-filter-no-matches {\n  height: 192px;\n}\n.ag-theme-material .ag-set-filter-filter {\n  margin-top: 16px;\n  margin-left: 12px;\n  margin-right: 12px;\n}\n.ag-theme-material .ag-filter-to {\n  margin-top: 14px;\n}\n.ag-theme-material .ag-mini-filter {\n  margin: 16px 12px;\n}\n.ag-theme-material .ag-set-filter-item {\n  margin: 0px 12px;\n}\n.ag-theme-material .ag-ltr .ag-set-filter-item-value {\n  margin-left: 12px;\n}\n\n.ag-theme-material .ag-rtl .ag-set-filter-item-value {\n  margin-right: 12px;\n}\n\n.ag-theme-material .ag-filter-apply-panel {\n  padding: 16px 12px;\n}\n.ag-theme-material .ag-filter-apply-panel-button {\n  line-height: 1.5;\n}\n.ag-theme-material .ag-ltr .ag-filter-apply-panel-button {\n  margin-left: 16px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-apply-panel-button {\n  margin-right: 16px;\n}\n\n.ag-theme-material .ag-simple-filter-body-wrapper {\n  padding: 16px 12px;\n  padding-bottom: 2px;\n}\n.ag-theme-material .ag-simple-filter-body-wrapper > * {\n  margin-bottom: 14px;\n}\n.ag-theme-material .ag-filter-no-matches {\n  padding: 16px 12px;\n}\n.ag-theme-material .ag-multi-filter-menu-item {\n  margin: 8px 0;\n}\n.ag-theme-material .ag-multi-filter-group-title-bar {\n  padding: 16px 8px;\n  background-color: transparent;\n}\n.ag-theme-material .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-multi-filter-group-title-bar:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-side-bar {\n  position: relative;\n}\n.ag-theme-material .ag-tool-panel-wrapper {\n  width: 200px;\n  background-color: #fafafa;\n  background-color: var(--ag-control-panel-background-color, #fafafa);\n}\n.ag-theme-material .ag-side-buttons {\n  padding-top: 32px;\n  width: 22px;\n  position: relative;\n  color: rgba(0, 0, 0, 0.87);\n  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));\n  overflow: hidden;\n}\n.ag-theme-material button.ag-side-button-button {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  background: transparent;\n  padding: 16px 0 16px 0;\n  width: 100%;\n  margin: 0;\n  min-height: 144px;\n  background-position-y: center;\n  background-position-x: center;\n  background-repeat: no-repeat;\n  border: none;\n}\n.ag-theme-material button.ag-side-button-button:focus {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-side-button-button:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-side-button-button:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-side-button-icon-wrapper {\n  margin-bottom: 3px;\n}\n.ag-theme-material .ag-ltr .ag-side-bar-left .ag-side-button-button,\n.ag-theme-material .ag-rtl .ag-side-bar-right .ag-side-button-button {\n  border-right: 2px solid transparent;\n}\n.ag-theme-material .ag-ltr .ag-side-bar-left .ag-selected .ag-side-button-button,\n.ag-theme-material .ag-rtl .ag-side-bar-right .ag-selected .ag-side-button-button {\n  border-right-color: #3f51b5;\n  border-right-color: var(--ag-selected-tab-underline-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-rtl .ag-side-bar-left .ag-side-button-button,\n.ag-theme-material .ag-ltr .ag-side-bar-right .ag-side-button-button {\n  border-left: 2px solid transparent;\n}\n.ag-theme-material .ag-rtl .ag-side-bar-left .ag-selected .ag-side-button-button,\n.ag-theme-material .ag-ltr .ag-side-bar-right .ag-selected .ag-side-button-button {\n  border-left-color: #3f51b5;\n  border-left-color: var(--ag-selected-tab-underline-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-filter-toolpanel-header {\n  height: 48px;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-header, .ag-theme-material .ag-ltr .ag-filter-toolpanel-search {\n  padding-left: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-header, .ag-theme-material .ag-rtl .ag-filter-toolpanel-search {\n  padding-right: 8px;\n}\n\n.ag-theme-material .ag-keyboard-focus .ag-filter-toolpanel-header:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-filter-toolpanel-header:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  font-family: \"agGridMaterial\";\n  font-size: 18px;\n  line-height: 18px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  content: \"\\f114\";\n  position: absolute;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  padding-left: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group.ag-has-filter > .ag-group-title-bar .ag-group-title::after {\n  padding-right: 8px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-0-header {\n  height: 64px;\n}\n.ag-theme-material .ag-filter-toolpanel-group-item {\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n.ag-theme-material .ag-filter-toolpanel-search {\n  height: 56px;\n}\n.ag-theme-material .ag-filter-toolpanel-search-input {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n  height: 32px;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-search-input {\n  margin-right: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-search-input {\n  margin-left: 8px;\n}\n\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-expand, .ag-theme-material .ag-ltr .ag-filter-toolpanel-group-title-bar-icon {\n  margin-right: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-expand, .ag-theme-material .ag-rtl .ag-filter-toolpanel-group-title-bar-icon {\n  margin-left: 8px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-1-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {\n  padding-left: 24px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-1 .ag-filter-toolpanel-group-level-2-header {\n  padding-right: 24px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-2-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {\n  padding-left: 40px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-2 .ag-filter-toolpanel-group-level-3-header {\n  padding-right: 40px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-3-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {\n  padding-left: 56px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-3 .ag-filter-toolpanel-group-level-4-header {\n  padding-right: 56px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-4-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {\n  padding-left: 72px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-4 .ag-filter-toolpanel-group-level-5-header {\n  padding-right: 72px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-5-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {\n  padding-left: 88px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-5 .ag-filter-toolpanel-group-level-6-header {\n  padding-right: 88px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-6-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {\n  padding-left: 104px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-6 .ag-filter-toolpanel-group-level-7-header {\n  padding-right: 104px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-7-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {\n  padding-left: 120px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-7 .ag-filter-toolpanel-group-level-8-header {\n  padding-right: 120px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-8-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {\n  padding-left: 136px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-8 .ag-filter-toolpanel-group-level-9-header {\n  padding-right: 136px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-9-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {\n  padding-left: 152px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-9 .ag-filter-toolpanel-group-level-10-header {\n  padding-right: 152px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-10-header.ag-filter-toolpanel-group-title-bar {\n  background-color: transparent;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {\n  padding-left: 168px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-group-level-10 .ag-filter-toolpanel-group-level-11-header {\n  padding-right: 168px;\n}\n\n.ag-theme-material .ag-filter-toolpanel-instance-header.ag-filter-toolpanel-group-level-1-header {\n  padding-left: 8px;\n}\n.ag-theme-material .ag-filter-toolpanel-instance-filter {\n  margin-top: 8px;\n}\n.ag-theme-material .ag-ltr .ag-filter-toolpanel-instance-header-icon {\n  margin-left: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-filter-toolpanel-instance-header-icon {\n  margin-right: 8px;\n}\n\n.ag-theme-material .ag-pivot-mode-panel {\n  min-height: 56px;\n  height: 56px;\n  display: -webkit-box;\n  display: flex;\n}\n.ag-theme-material .ag-pivot-mode-select {\n  display: -webkit-box;\n  display: flex;\n  -webkit-box-align: center;\n          align-items: center;\n}\n.ag-theme-material .ag-ltr .ag-pivot-mode-select {\n  margin-left: 12px;\n}\n\n.ag-theme-material .ag-rtl .ag-pivot-mode-select {\n  margin-right: 12px;\n}\n\n.ag-theme-material .ag-keyboard-focus .ag-column-select-header:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-column-select-header:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-column-select-header {\n  height: 56px;\n  -webkit-box-align: center;\n          align-items: center;\n  padding: 0 12px;\n}\n.ag-theme-material .ag-column-group-icons,\n.ag-theme-material .ag-column-select-header-icon {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-column-select-list .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #3f51b5;\n  background-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-column-select-list .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-theme-material .ag-column-select-list .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n.ag-theme-material .ag-header {\n  background-color: #fff;\n  background-color: var(--ag-header-background-color, #fff);\n  border-bottom: solid 1px;\n  border-bottom-color: #e2e2e2;\n  border-bottom-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-header-row {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));\n  height: 56px;\n}\n.ag-theme-material .ag-pinned-right-header {\n  border-left: solid 1px;\n  border-left-color: #e2e2e2;\n  border-left-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-pinned-left-header {\n  border-right: solid 1px;\n  border-right-color: #e2e2e2;\n  border-right-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-ltr .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {\n  margin-left: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-header-cell:not(.ag-right-aligned-header) .ag-header-label-icon {\n  margin-right: 8px;\n}\n\n.ag-theme-material .ag-ltr .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {\n  margin-right: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-header-cell.ag-right-aligned-header .ag-header-label-icon {\n  margin-left: 8px;\n}\n\n.ag-theme-material .ag-header-cell,\n.ag-theme-material .ag-header-group-cell {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n.ag-theme-material .ag-header-cell.ag-header-cell-moving,\n.ag-theme-material .ag-header-group-cell.ag-header-cell-moving {\n  background-color: #f2f2f2;\n  background-color: var(--ag-header-cell-moving-background-color, var(--ag-header-cell-hover-background-color, #f2f2f2));\n}\n.ag-theme-material .ag-keyboard-focus .ag-header-cell:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-header-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-keyboard-focus .ag-header-group-cell:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-header-group-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 4px;\n  left: 4px;\n  display: block;\n  width: calc(100% - 8px);\n  height: calc(100% - 8px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-header-icon {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-header-expand-icon {\n  cursor: pointer;\n}\n.ag-theme-material .ag-ltr .ag-header-expand-icon {\n  padding-left: 4px;\n}\n\n.ag-theme-material .ag-rtl .ag-header-expand-icon {\n  padding-right: 4px;\n}\n\n.ag-theme-material .ag-header-row:not(:first-child) .ag-header-cell,\n.ag-theme-material .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {\n  border-top: solid 1px;\n  border-top-color: #e2e2e2;\n  border-top-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell:not(.ag-header-cell-moving):hover, .ag-theme-material .ag-header-group-cell:not(.ag-column-resizing) + .ag-header-group-cell.ag-column-resizing,\n.ag-theme-material .ag-header-cell:not(.ag-column-resizing) + .ag-header-cell:not(.ag-header-cell-moving):hover,\n.ag-theme-material .ag-header-cell:not(.ag-column-resizing) + .ag-header-cell.ag-column-resizing,\n.ag-theme-material .ag-header-group-cell:first-of-type:not(.ag-header-cell-moving):hover,\n.ag-theme-material .ag-header-group-cell:first-of-type.ag-column-resizing,\n.ag-theme-material .ag-header-cell:first-of-type:not(.ag-header-cell-moving):hover,\n.ag-theme-material .ag-header-cell:first-of-type.ag-column-resizing {\n  background-color: #f2f2f2;\n  background-color: var(--ag-header-cell-hover-background-color, #f2f2f2);\n}\n.ag-theme-material .ag-ltr .ag-header-select-all {\n  margin-right: 24px;\n}\n\n.ag-theme-material .ag-rtl .ag-header-select-all {\n  margin-left: 24px;\n}\n\n.ag-theme-material .ag-ltr .ag-floating-filter-button {\n  margin-left: 24px;\n}\n\n.ag-theme-material .ag-rtl .ag-floating-filter-button {\n  margin-right: 24px;\n}\n\n.ag-theme-material .ag-floating-filter-button-button {\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background: transparent;\n  border: none;\n  height: 18px;\n  padding: 0;\n  width: 18px;\n}\n.ag-theme-material .ag-filter-loading {\n  background-color: #fafafa;\n  background-color: var(--ag-control-panel-background-color, #fafafa);\n  height: 100%;\n  padding: 16px 12px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n.ag-theme-material .ag-paging-panel {\n  border-top: 1px solid;\n  border-top-color: #e2e2e2;\n  border-top-color: var(--ag-border-color, #e2e2e2);\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n  height: 56px;\n}\n.ag-theme-material .ag-paging-panel > * {\n  margin: 0 24px;\n}\n.ag-theme-material .ag-paging-button {\n  cursor: pointer;\n}\n.ag-theme-material .ag-paging-button.ag-disabled {\n  cursor: default;\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-material .ag-keyboard-focus .ag-paging-button:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-paging-button:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 0px;\n  left: 0px;\n  display: block;\n  width: calc(100% - 0px);\n  height: calc(100% - 0px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-paging-button, .ag-theme-material .ag-paging-description {\n  margin: 0 8px;\n}\n.ag-theme-material .ag-status-bar {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  padding-right: 32px;\n  padding-left: 32px;\n  line-height: 1.5;\n}\n.ag-theme-material .ag-status-name-value-value {\n  color: rgba(0, 0, 0, 0.87);\n  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));\n}\n.ag-theme-material .ag-status-bar-center {\n  text-align: center;\n}\n.ag-theme-material .ag-status-name-value {\n  margin-left: 8px;\n  margin-right: 8px;\n  padding-top: 16px;\n  padding-bottom: 16px;\n}\n.ag-theme-material .ag-column-drop-cell {\n  background: #e2e2e2;\n  background: var(--ag-chip-background-color, #e2e2e2);\n  border-radius: 32px;\n  height: 32px;\n  padding: 0 4px;\n  border: 1px solid transparent;\n}\n.ag-theme-material .ag-keyboard-focus .ag-column-drop-cell:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-column-drop-cell:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 2px;\n  left: 2px;\n  display: block;\n  width: calc(100% - 4px);\n  height: calc(100% - 4px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-column-drop-cell-text {\n  margin: 0 8px;\n}\n.ag-theme-material .ag-column-drop-cell-button {\n  min-width: 32px;\n  margin: 0 4px;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-column-drop-cell-drag-handle {\n  margin-left: 16px;\n}\n.ag-theme-material .ag-column-drop-cell-ghost {\n  opacity: 0.5;\n}\n.ag-theme-material .ag-column-drop-horizontal {\n  background-color: #fafafa;\n  background-color: var(--ag-control-panel-background-color, #fafafa);\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n  height: 48px;\n}\n.ag-theme-material .ag-ltr .ag-column-drop-horizontal {\n  padding-left: 24px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-drop-horizontal {\n  padding-right: 24px;\n}\n\n.ag-theme-material .ag-column-drop-horizontal-cell-separator {\n  margin: 0 8px;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-column-drop-horizontal-empty-message {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-material .ag-ltr .ag-column-drop-horizontal-icon {\n  margin-right: 24px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-drop-horizontal-icon {\n  margin-left: 24px;\n}\n\n.ag-theme-material .ag-column-drop-vertical-list {\n  padding-bottom: 8px;\n  padding-right: 8px;\n  padding-left: 8px;\n}\n.ag-theme-material .ag-column-drop-vertical-cell {\n  margin-top: 8px;\n}\n.ag-theme-material .ag-column-drop-vertical {\n  min-height: 50px;\n}\n.ag-theme-material .ag-column-drop-vertical-icon {\n  margin-left: 8px;\n  margin-right: 8px;\n}\n.ag-theme-material .ag-column-drop-vertical-empty-message {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: hidden;\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  margin-top: 8px;\n}\n.ag-theme-material .ag-select-agg-func-popup {\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  border-radius: 2px;\n  -webkit-box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n          box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n  padding: 8px;\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n  height: 140px;\n  padding: 0;\n}\n.ag-theme-material .ag-select-agg-func-virtual-list-item {\n  cursor: default;\n  padding-left: 16px;\n}\n.ag-theme-material .ag-select-agg-func-virtual-list-item:hover {\n  background-color: #eee;\n  background-color: var(--ag-selected-row-background-color, #eee);\n}\n.ag-theme-material .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus {\n  outline: none;\n}\n.ag-theme-material .ag-keyboard-focus .ag-select-agg-func-virtual-list-item:focus::after {\n  content: \"\";\n  position: absolute;\n  background-color: transparent;\n  pointer-events: none;\n  top: 1px;\n  left: 1px;\n  display: block;\n  width: calc(100% - 2px);\n  height: calc(100% - 2px);\n  border: 1px solid;\n  border-color: #3f51b5;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-chart-menu {\n  border-radius: 2px;\n  background: #fff;\n  background: var(--ag-background-color, #fff);\n}\n.ag-theme-material .ag-chart-menu-icon {\n  opacity: 0.5;\n  line-height: 24px;\n  font-size: 24px;\n  width: 24px;\n  height: 24px;\n  margin: 2px 0;\n  cursor: pointer;\n  border-radius: 2px;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-chart-menu-icon:hover {\n  opacity: 1;\n}\n.ag-theme-material .ag-chart-mini-thumbnail {\n  border: 1px solid;\n  border-color: #e2e2e2;\n  border-color: var(--ag-secondary-border-color, var(--ag-border-color, #e2e2e2));\n  border-radius: 5px;\n  margin: 5px;\n}\n.ag-theme-material .ag-chart-mini-thumbnail:nth-last-child(3), .ag-theme-material .ag-chart-mini-thumbnail:nth-last-child(3) ~ .ag-chart-mini-thumbnail {\n  margin-left: auto;\n  margin-right: auto;\n}\n.ag-theme-material .ag-ltr .ag-chart-mini-thumbnail:first-child {\n  margin-left: 0;\n}\n\n.ag-theme-material .ag-rtl .ag-chart-mini-thumbnail:first-child {\n  margin-right: 0;\n}\n\n.ag-theme-material .ag-ltr .ag-chart-mini-thumbnail:last-child {\n  margin-right: 0;\n}\n\n.ag-theme-material .ag-rtl .ag-chart-mini-thumbnail:last-child {\n  margin-left: 0;\n}\n\n.ag-theme-material .ag-chart-mini-thumbnail.ag-selected {\n  border-color: #ff4081;\n  border-color: var(--ag-minichart-selected-chart-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));\n}\n.ag-theme-material .ag-chart-settings-card-item {\n  background: rgba(0, 0, 0, 0.87);\n  background: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n}\n.ag-theme-material .ag-chart-settings-card-item.ag-selected {\n  background-color: #ff4081;\n  background-color: var(--ag-minichart-selected-page-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));\n}\n.ag-theme-material .ag-chart-data-column-drag-handle {\n  margin-left: 8px;\n}\n.ag-theme-material .ag-charts-settings-group-container {\n  padding: 8px;\n}\n.ag-theme-material .ag-charts-data-group-container {\n  padding: 8px 12px;\n}\n.ag-theme-material .ag-charts-data-group-container .ag-charts-data-group-item:not(.ag-charts-format-sub-level-group) {\n  height: 32px;\n}\n.ag-theme-material .ag-charts-data-group-container .ag-list-item-hovered::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background-color: #3f51b5;\n  background-color: var(--ag-range-selection-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material .ag-charts-data-group-container .ag-item-highlight-top::after {\n  top: 0;\n}\n.ag-theme-material .ag-charts-data-group-container .ag-item-highlight-bottom::after {\n  bottom: 0;\n}\n.ag-theme-material .ag-charts-format-top-level-group-container {\n  margin-left: 16px;\n  padding: 8px;\n}\n.ag-theme-material .ag-charts-format-top-level-group-item {\n  margin: 8px 0;\n}\n.ag-theme-material .ag-charts-format-sub-level-group-container {\n  padding: 16px 12px;\n  padding-bottom: 2px;\n}\n.ag-theme-material .ag-charts-format-sub-level-group-container > * {\n  margin-bottom: 14px;\n}\n.ag-theme-material .ag-charts-group-container.ag-group-container-horizontal {\n  padding: 8px;\n}\n.ag-theme-material .ag-chart-data-section,\n.ag-theme-material .ag-chart-format-section {\n  display: -webkit-box;\n  display: flex;\n  margin: 0;\n}\n.ag-theme-material .ag-chart-menu-panel {\n  background-color: #fafafa;\n  background-color: var(--ag-control-panel-background-color, #fafafa);\n}\n.ag-theme-material .ag-ltr .ag-chart-menu-panel {\n  border-left: solid 1px;\n  border-left-color: #e2e2e2;\n  border-left-color: var(--ag-border-color, #e2e2e2);\n}\n\n.ag-theme-material .ag-rtl .ag-chart-menu-panel {\n  border-right: solid 1px;\n  border-right-color: #e2e2e2;\n  border-right-color: var(--ag-border-color, #e2e2e2);\n}\n\n.ag-theme-material .ag-date-time-list-page-title {\n  -webkit-box-flex: 1;\n          flex-grow: 1;\n  text-align: center;\n}\n.ag-theme-material .ag-date-time-list-page-column-label {\n  text-align: center;\n}\n.ag-theme-material .ag-date-time-list-page-entry {\n  text-align: center;\n}\n.ag-theme-material .ag-checkbox-input-wrapper {\n  font-family: \"agGridMaterial\";\n  font-size: 18px;\n  line-height: 18px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: 18px;\n  height: 18px;\n  background-color: var(--ag-checkbox-background-color);\n  border-radius: 2px;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-box-flex: 0;\n          flex: none;\n}\n.ag-theme-material .ag-checkbox-input-wrapper input, .ag-theme-material .ag-checkbox-input-wrapper input {\n  -webkit-appearance: none;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n.ag-theme-material .ag-checkbox-input-wrapper:focus-within, .ag-theme-material .ag-checkbox-input-wrapper:active {\n  outline: none;\n  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n}\n.ag-theme-material .ag-checkbox-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-material .ag-checkbox-input-wrapper::after {\n  content: \"\\f108\";\n  color: #333;\n  color: var(--ag-checkbox-unchecked-color, #333);\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-material .ag-checkbox-input-wrapper.ag-checked::after {\n  content: \"\\f106\";\n  color: #ff4081;\n  color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-material .ag-checkbox-input-wrapper.ag-indeterminate::after {\n  content: \"\\f107\";\n  color: #333;\n  color: var(--ag-checkbox-indeterminate-color, var(--ag-checkbox-unchecked-color, #333));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-material .ag-toggle-button-input-wrapper {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 36px;\n  height: 18px;\n  background-color: #333;\n  background-color: var(--ag-toggle-button-off-background-color, var(--ag-checkbox-unchecked-color, #333));\n  border-radius: 9px;\n  position: relative;\n  -webkit-box-flex: 0;\n          flex: none;\n  border: 1px solid;\n  border-color: #333;\n  border-color: var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #333));\n}\n.ag-theme-material .ag-toggle-button-input-wrapper input {\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n}\n.ag-theme-material .ag-toggle-button-input-wrapper:focus-within {\n  outline: none;\n  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n}\n.ag-theme-material .ag-toggle-button-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-material .ag-toggle-button-input-wrapper.ag-checked {\n  background-color: #ff4081;\n  background-color: var(--ag-toggle-button-on-background-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));\n  border-color: #ff4081;\n  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));\n}\n.ag-theme-material .ag-toggle-button-input-wrapper::before {\n  content: \" \";\n  position: absolute;\n  top: -1px;\n  left: -1px;\n  display: block;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 18px;\n  width: 18px;\n  background-color: #fff;\n  background-color: var(--ag-toggle-button-switch-background-color, var(--ag-background-color, #fff));\n  border-radius: 9px;\n  -webkit-transition: left 100ms;\n  transition: left 100ms;\n  border: 1px solid;\n  border-color: #333;\n  border-color: var(--ag-toggle-button-switch-border-color, var(--ag-toggle-button-off-border-color, var(--ag-checkbox-unchecked-color, #333)));\n}\n.ag-theme-material .ag-toggle-button-input-wrapper.ag-checked::before {\n  left: calc(100% - 18px );\n  border-color: #ff4081;\n  border-color: var(--ag-toggle-button-on-border-color, var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081)));\n}\n.ag-theme-material .ag-radio-button-input-wrapper {\n  font-family: \"agGridMaterial\";\n  font-size: 18px;\n  line-height: 18px;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  width: 18px;\n  height: 18px;\n  background-color: var(--ag-checkbox-background-color);\n  border-radius: 2px;\n  display: inline-block;\n  vertical-align: middle;\n  -webkit-box-flex: 0;\n          flex: none;\n  border-radius: 18px;\n}\n.ag-theme-material .ag-radio-button-input-wrapper input, .ag-theme-material .ag-radio-button-input-wrapper input {\n  -webkit-appearance: none;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n}\n.ag-theme-material .ag-radio-button-input-wrapper:focus-within, .ag-theme-material .ag-radio-button-input-wrapper:active {\n  outline: none;\n  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n}\n.ag-theme-material .ag-radio-button-input-wrapper.ag-disabled {\n  opacity: 0.5;\n}\n.ag-theme-material .ag-radio-button-input-wrapper::after {\n  content: \"\\f126\";\n  color: #333;\n  color: var(--ag-checkbox-unchecked-color, #333);\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-material .ag-radio-button-input-wrapper.ag-checked::after {\n  content: \"\\f127\";\n  color: #ff4081;\n  color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));\n  position: absolute;\n  top: 0;\n  left: 0;\n  pointer-events: none;\n}\n.ag-theme-material input[class^=ag-][type=range] {\n  -webkit-appearance: none;\n  width: 100%;\n  height: 100%;\n  background: none;\n  overflow: visible;\n}\n.ag-theme-material input[class^=ag-][type=range]::-webkit-slider-runnable-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #e2e2e2;\n  background-color: var(--ag-border-color, #e2e2e2);\n  border-radius: 0px;\n  border-radius: 2px;\n}\n.ag-theme-material input[class^=ag-][type=range]::-moz-range-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #e2e2e2;\n  background-color: var(--ag-border-color, #e2e2e2);\n  border-radius: 0px;\n  border-radius: 2px;\n}\n.ag-theme-material input[class^=ag-][type=range]::-ms-track {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 3px;\n  background-color: #e2e2e2;\n  background-color: var(--ag-border-color, #e2e2e2);\n  border-radius: 0px;\n  border-radius: 2px;\n  color: transparent;\n  width: calc(100% - 2px);\n}\n.ag-theme-material input[class^=ag-][type=range]::-webkit-slider-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 18px;\n  height: 18px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  border: 1px solid;\n  border-color: #333;\n  border-color: var(--ag-checkbox-unchecked-color, #333);\n  border-radius: 18px;\n  -webkit-transform: translateY(-7.5px);\n          transform: translateY(-7.5px);\n}\n.ag-theme-material input[class^=ag-][type=range]::-ms-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 18px;\n  height: 18px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  border: 1px solid;\n  border-color: #333;\n  border-color: var(--ag-checkbox-unchecked-color, #333);\n  border-radius: 18px;\n}\n.ag-theme-material input[class^=ag-][type=range]::-moz-ag-range-thumb {\n  margin: 0;\n  padding: 0;\n  -webkit-appearance: none;\n  width: 18px;\n  height: 18px;\n  background-color: #fff;\n  background-color: var(--ag-background-color, #fff);\n  border: 1px solid;\n  border-color: #333;\n  border-color: var(--ag-checkbox-unchecked-color, #333);\n  border-radius: 18px;\n}\n.ag-theme-material input[class^=ag-][type=range]:focus {\n  outline: none;\n}\n.ag-theme-material input[class^=ag-][type=range]:focus::-webkit-slider-thumb {\n  -webkit-box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n          box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n  border-color: #ff4081;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));\n}\n.ag-theme-material input[class^=ag-][type=range]:focus::-ms-thumb {\n  box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n  border-color: #ff4081;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));\n}\n.ag-theme-material input[class^=ag-][type=range]:focus::-moz-ag-range-thumb {\n  box-shadow: 0 0 0 5px rgba(32, 33, 36, 0.122);\n  border-color: #ff4081;\n  border-color: var(--ag-checkbox-checked-color, var(--ag-material-accent-color, #ff4081));\n}\n.ag-theme-material input[class^=ag-][type=range]:active::-webkit-slider-runnable-track {\n  background-color: #3f51b5;\n  background-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material input[class^=ag-][type=range]:active::-moz-ag-range-track {\n  background-color: #3f51b5;\n  background-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material input[class^=ag-][type=range]:active::-ms-track {\n  background-color: #3f51b5;\n  background-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5));\n}\n.ag-theme-material input[class^=ag-][type=range]:disabled {\n  opacity: 0.5;\n}\n.ag-theme-material .ag-filter-toolpanel-header,\n.ag-theme-material .ag-filter-toolpanel-search,\n.ag-theme-material .ag-status-bar,\n.ag-theme-material .ag-header-row,\n.ag-theme-material .ag-panel-title-bar-title,\n.ag-theme-material .ag-side-button-button,\n.ag-theme-material .ag-multi-filter-group-title-bar {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-header-foreground-color, var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54)));\n}\n.ag-theme-material .ag-tab {\n  height: 36px;\n}\n.ag-theme-material .ag-tabs-header,\n.ag-theme-material .ag-column-drop-horizontal {\n  background-color: #eee;\n  background-color: var(--ag-subheader-background-color, #eee);\n}\n.ag-theme-material .ag-tabs-body {\n  padding: 4px 0;\n}\n.ag-theme-material .ag-tabs-body .ag-menu-list {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.ag-theme-material .ag-header-cell, .ag-theme-material .ag-header-group-cell {\n  -webkit-transition: background-color 0.5s;\n  transition: background-color 0.5s;\n}\n.ag-theme-material .ag-row-last:not(.ag-row-first) .ag-cell-inline-editing {\n  bottom: 0;\n}\n.ag-theme-material .ag-cell-inline-editing {\n  padding: 8px;\n  height: 72px;\n  border-color: #e2e2e2 !important;\n  border-color: var(--ag-border-color, #e2e2e2) !important;\n}\n.ag-theme-material .ag-has-focus .ag-cell-inline-editing {\n  border-color: #3f51b5 !important;\n  border-color: var(--ag-input-focus-border-color, var(--ag-material-primary-color, #3f51b5)) !important;\n}\n.ag-theme-material .ag-side-button-button {\n  color: rgba(0, 0, 0, 0.54);\n  color: var(--ag-secondary-foreground-color, rgba(0, 0, 0, 0.54));\n}\n.ag-theme-material .ag-column-drop-vertical {\n  border-bottom: solid 1px;\n  border-bottom-color: #e2e2e2;\n  border-bottom-color: var(--ag-border-color, #e2e2e2);\n  padding-top: 8px;\n}\n.ag-theme-material .ag-column-drop-vertical.ag-last-column-drop {\n  border-bottom: none;\n}\n.ag-theme-material .ag-column-drop-vertical-cell {\n  margin-left: 0;\n}\n.ag-theme-material .ag-column-drop-vertical-empty-message {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-material .ag-ltr .ag-column-drop-vertical-empty-message {\n  padding-left: 34px;\n  padding-right: 8px;\n}\n\n.ag-theme-material .ag-rtl .ag-column-drop-vertical-empty-message {\n  padding-right: 34px;\n  padding-left: 8px;\n}\n\n.ag-theme-material .ag-status-bar {\n  border: solid 1px;\n  border-color: #e2e2e2;\n  border-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-column-panel-column-select {\n  border-top: solid 1px;\n  border-top-color: #e2e2e2;\n  border-top-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-column-select, .ag-theme-material .ag-column-select-header {\n  border-bottom: solid 1px;\n  border-bottom-color: #e2e2e2;\n  border-bottom-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material .ag-column-select-header {\n  height: 56px;\n}\n.ag-theme-material .ag-group-title-bar {\n  padding: 6px 8px;\n}\n.ag-theme-material .ag-charts-format-sub-level-group-title-bar {\n  padding: 4px 8px;\n}\n.ag-theme-material .ag-chart-data-section,\n.ag-theme-material .ag-chart-format-section {\n  padding-bottom: 4px;\n}\n.ag-theme-material .ag-group-toolbar {\n  background-color: rgba(238, 238, 238, 0.5);\n}\n.ag-theme-material input[class^=ag-]:not([type]),\n.ag-theme-material input[class^=ag-][type=text],\n.ag-theme-material input[class^=ag-][type=number],\n.ag-theme-material input[class^=ag-][type=tel],\n.ag-theme-material input[class^=ag-][type=date],\n.ag-theme-material input[class^=ag-][type=datetime-local],\n.ag-theme-material textarea[class^=ag-] {\n  background: transparent;\n  color: rgba(0, 0, 0, 0.87);\n  color: var(--ag-foreground-color, rgba(0, 0, 0, 0.87));\n  font-family: inherit;\n  font-size: inherit;\n  height: 40px;\n  padding-bottom: 8px;\n  border-width: 0;\n  border-bottom: 2px solid;\n  border-bottom-color: #e2e2e2;\n  border-bottom-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material input[class^=ag-]:focus:not([type]),\n.ag-theme-material input[class^=ag-][type=text]:focus,\n.ag-theme-material input[class^=ag-][type=number]:focus,\n.ag-theme-material input[class^=ag-][type=tel]:focus,\n.ag-theme-material input[class^=ag-][type=date]:focus,\n.ag-theme-material input[class^=ag-][type=datetime-local]:focus,\n.ag-theme-material textarea[class^=ag-]:focus {\n  border-bottom: 2px solid;\n  border-bottom-color: #3f51b5;\n  border-bottom-color: var(--ag-material-primary-color, #3f51b5);\n  outline: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.ag-theme-material input[class^=ag-]:not([type])::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=text]::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=number]::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=tel]::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=date]::-webkit-input-placeholder, .ag-theme-material input[class^=ag-][type=datetime-local]::-webkit-input-placeholder, .ag-theme-material textarea[class^=ag-]::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-material input[class^=ag-]:not([type])::-moz-placeholder, .ag-theme-material input[class^=ag-][type=text]::-moz-placeholder, .ag-theme-material input[class^=ag-][type=number]::-moz-placeholder, .ag-theme-material input[class^=ag-][type=tel]::-moz-placeholder, .ag-theme-material input[class^=ag-][type=date]::-moz-placeholder, .ag-theme-material input[class^=ag-][type=datetime-local]::-moz-placeholder, .ag-theme-material textarea[class^=ag-]::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-material input[class^=ag-]:not([type])::placeholder,\n.ag-theme-material input[class^=ag-][type=text]::placeholder,\n.ag-theme-material input[class^=ag-][type=number]::placeholder,\n.ag-theme-material input[class^=ag-][type=tel]::placeholder,\n.ag-theme-material input[class^=ag-][type=date]::placeholder,\n.ag-theme-material input[class^=ag-][type=datetime-local]::placeholder,\n.ag-theme-material textarea[class^=ag-]::placeholder {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n}\n.ag-theme-material input[class^=ag-]:disabled:not([type]),\n.ag-theme-material input[class^=ag-][type=text]:disabled,\n.ag-theme-material input[class^=ag-][type=number]:disabled,\n.ag-theme-material input[class^=ag-][type=tel]:disabled,\n.ag-theme-material input[class^=ag-][type=date]:disabled,\n.ag-theme-material input[class^=ag-][type=datetime-local]:disabled,\n.ag-theme-material textarea[class^=ag-]:disabled {\n  border-bottom: 1px solid;\n  border-bottom-color: #e2e2e2;\n  border-bottom-color: var(--ag-border-color, #e2e2e2);\n}\n.ag-theme-material input[class^=ag-]:invalid:not([type]),\n.ag-theme-material input[class^=ag-][type=text]:invalid,\n.ag-theme-material input[class^=ag-][type=number]:invalid,\n.ag-theme-material input[class^=ag-][type=tel]:invalid,\n.ag-theme-material input[class^=ag-][type=date]:invalid,\n.ag-theme-material input[class^=ag-][type=datetime-local]:invalid,\n.ag-theme-material textarea[class^=ag-]:invalid {\n  border-width: 0;\n  border-bottom: 1px solid;\n  border-bottom-color: #e02525;\n  border-bottom-color: var(--ag-invalid-color, #e02525);\n  color: #e02525;\n  color: var(--ag-invalid-color, #e02525);\n}\n.ag-theme-material .ag-standard-button {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-color: transparent;\n  border: 0;\n  color: #3f51b5;\n  color: var(--ag-material-primary-color, #3f51b5);\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  padding: 0;\n  text-transform: uppercase;\n}\n.ag-theme-material .ag-standard-button:disabled {\n  color: rgba(0, 0, 0, 0.38);\n  color: var(--ag-disabled-foreground-color, rgba(0, 0, 0, 0.38));\n  background-color: var(--ag-input-disabled-background-color);\n  border-color: var(--ag-input-disabled-border-color);\n}\n.ag-theme-material .ag-dnd-ghost {\n  font-size: 12px;\n  font-weight: 600;\n}\n.ag-theme-material .ag-filter-toolpanel-header {\n  height: 32px;\n}\n.ag-theme-material .ag-filter-toolpanel-group-level-0-header {\n  height: 56px;\n}\n.ag-theme-material .ag-layout-auto-height .ag-center-cols-clipper, .ag-theme-material .ag-layout-auto-height .ag-center-cols-container, .ag-theme-material .ag-layout-print .ag-center-cols-clipper, .ag-theme-material .ag-layout-print .ag-center-cols-container {\n  min-height: 150px;\n}\n.ag-theme-material .ag-overlay-no-rows-wrapper.ag-layout-auto-height {\n  padding-top: 60px;\n}\n.ag-theme-material .ag-picker-field-wrapper:focus {\n  -webkit-box-shadow: 0 0 0 1px #3f51b5;\n          box-shadow: 0 0 0 1px #3f51b5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
